<template>
<el-container class="hoteldetail-main" id="main">
  <publicHeader @hotelDetailCurrency='hotelDetailCurrency' @hotelLanguage="hotelLanguage" :hotelLogoFixed="hotelLogoFixed"></publicHeader>
  <GoogleOneTouch :lang="1"></GoogleOneTouch>
  <el-main>
      <div class="main">
        <publicSearchCond ref="child" :regionSelData="regionSelDetail" :hotelRoomSearchFixed="hotelRoomSearchFixedHeader" :hotelRoomSearchFixedPlaceholder="hotelRoomSearchFixedHeaderPlaceholder" @getSearchInfo="getSearchInfo"></publicSearchCond>
        <!--搜索结果 开始-->
        <div class="list-content" :style="listContentStyle">
          <el-skeleton animated :loading="hotelShow">
            <template slot="template">
              <div class="directory">
                <el-skeleton-item variant="text" style="width: 40px;" />
                <span class="slash">/</span>
                <el-skeleton-item variant="text" style="width: 40px;" />
                <span class="slash">/</span>
                <el-skeleton-item variant="text" style="width: 40px;" />
                <span class="slash">/</span>
                <el-skeleton-item variant="text" style="width: 150px;" />
              </div>
            </template>
            <template>
              <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                <div class="directory">
                  <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">{{$t('home')}}</router-link>
                  <span v-if="JSON.stringify(hotel) !== '{}' && JSON.stringify(hotel.countryBase) !== '{}'">
                    <span class="slash">/</span>
                    <span v-html="getLanguageHtml(hotel,'country')"></span>
                  </span>
                  <span v-if="JSON.stringify(hotel) !== '{}' && JSON.stringify(hotel.cityBase) !== '{}'">
                    <span class="slash">/</span>
                    <span v-html="getLanguageHtml(hotel,'city')" @click="selectHotelList" class="curPointer"></span>
                  </span>
                  <span v-if="JSON.stringify(hotel) !== '{}' && hotel.hotelname !== ''">
                    <span class="slash">/</span>
                    <span v-html="getLanguageHtml(hotel,'hotelname')" style="color:#5392F9"></span>
                  </span>
                </div>
              </el-card>
            </template>
          </el-skeleton>

          <!-- 酒店详情 开始 -->
          <div class="hotel-detail">
              <!-- 酒店描述 开始  -->
              <div class="hotel-detail-info hotel-detail-info-pc">
                <el-skeleton animated :loading="hotelShow">
                  <template slot="template">
                    <!-- 酒店名称地址 开始 -->
                    <div class="hotel-detail-data">
                        <div class="hotel-detail-name"><el-skeleton-item variant="text" style="height:36px; width: 50%;"/></div>
                        <div class="hotel-detail-addr"><el-skeleton-item variant="text"/></div>
                    </div>
                    <!-- 酒店名称地址 结束 -->
                    <!-- 酒店图片设施 开始 -->
                    <div class="hotel-detail-describe">
                        <div class="hotel-detail-img" style="position: relative;">
                          <div class="hotel-detail-img-max">
                            <el-skeleton-item variant="text" class="hotel-imgs"/>
                          </div>
                          <div class="hotel-detail-img-min hotel-detail-img-love"><el-skeleton-item variant="text" class="hotel-imgs"/></div>
                          <div class="hotel-detail-img-min hotel-detail-img-all"><el-skeleton-item variant="text" class="hotel-imgs"/></div>
                        </div>
                        <div class="hotel-detail-other">
                          <div class="hotel-detail-evaluate-map">
                              <div class="hotel-detail-evaluate" style="border: none;"><el-skeleton-item variant="text" style="height: 100%; width: 100%;"/></div>
                              <div class="hotel-detail-map" >
                                  <div class="hotel-detail-map-img">
                                    <el-skeleton-item variant="text" style="width: 100%;height: 100%;"/>
                                  </div>
                                  <div class="hotel-detail-map-info">
                                      <div class="map-info map-info-fly" v-for="index in 3" :key="index">
                                        <el-skeleton-item variant="text"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="hotel-detail-device-around-division">
                            <img src="/static/img/hotelsearch/division.svg" alt="">
                          </div>
                          <div class="hotel-detail-device-around">
                              <div class="device-around-class">
                                  <div class="hotel-detail-device">
                                      <div class="hotel-detail-device-line"  v-for="index in 5" :key="index">
                                        <el-skeleton-item variant="text" style="width: 90%;"/>
                                      </div>
                                      <div class="hotel-detail-device-line more-line" @click="anchorJumpLine('hotel-facilities')">
                                        <el-skeleton-item variant="text" style="width: 60%;"/>
                                      </div>
                                  </div>
                                  <div class="hotel-detail-around">
                                      <el-skeleton-item variant="text" class="hotel-detail-around-line first-line" style="width: 70px; margin-left: 10px;"/>
                                      <div class="hotel-detail-around-line" v-for="index in 4" :key="index">
                                        <el-skeleton-item variant="text" style="width: 95%;"/>
                                      </div>
                                      <div class="hotel-detail-around-line more-line" @click="anchorJumpLine('hotel-overview')">
                                        <el-skeleton-item variant="text" style="width: 60%;"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                    <!-- 酒店图片设施 结束 -->
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                    <!-- 酒店名称地址 开始 -->
                    <div class="hotel-detail-data">
                      <div class="hotel-detail-name">
                        <span v-html="getLanguageHtml(hotel,'hotelname')"></span>
                        <span class="hotel-detail-star">
                          <b style="margin-right: 3px;" v-for="val in hotelInfo.star" :key="val">
                            <img style="width:15px;height:15px;" src="/static/img/star.png">
                          </b>
                          <b style="margin-left: -3px;" v-if="hotelInfo.star_decimal === 1">
                            <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                          </b>
                        </span>
                      </div>
                      <div class="hotel-detail-addr"><span v-html="getLanguageHtml(hotel,'hoteladdr')"></span></div>
                    </div>
                    <!-- 酒店名称地址 结束 -->
                    <!-- 酒店图片设施 开始 -->
                    <div class="hotel-detail-describe">
                        <div class="hotel-detail-img" style="position: relative;">
                          <div class="hotel-detail-img-max">
                              <img :src="hotelImg[0].url" class="hotel-imgs" alt="">
                          </div>
                          <div class="hotel-detail-img-min hotel-detail-img-love">
                              <img :src="hotelImg[1]['url']" class="hotel-imgs" alt="">
                              <!-- <span><img src="https://res.roompai.com/static/img/hotelsearch/xin.svg" alt="" class="hotel-img-love"></span> -->
                              <!-- <div :class="'hotel-like-'+hotelCollect.islike" @click="collect('match', hotel.hotelid, hotelCollect.islike)"></div> -->
                              <svg @click="collect(hotel.hotelid, hotelCollect.islike)" :class="'hotel-like-'+hotelCollect.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0" style="z-index:101">
                                <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                              </svg>
                          </div>
                          <div class="hotel-detail-img-min hotel-detail-img-all">
                              <img :src="hotelImg[2]['url']" class="hotel-imgs" alt="">
                              <span v-if="hotelImg[2]['defect'] === 0" @click="seeMorePicturesShow($event)">{{$t('seeAllPhotos')}}</span>
                          </div>
                          <div v-if="hotelImg[0].defect === 1" style="position: absolute;top: 0px;background: rgb(0,0,0,0.4);width: 100%;height: 100%;border-radius: 4px;z-index:100">
                            <div style="margin: 30px;color: white;font-weight: 545;">暂无图片</div>
                          </div>
                        </div>
                        <div class="hotel-detail-other">
                          <div class="hotel-detail-evaluate-map">
                              <div class="hotel-detail-evaluate">
                                  <div class="hotel-detail-evaluate-num">
                                    <span>{{hotelInfo.hotelscore}}</span>
                                    <b v-html="getLanguageHtml(hotelInfo.hotelscoreStr, 'hotelscoreStr')"></b>
                                  </div>
                                  <div class="hotel-detail-evaluate-desc">
                                      <!-- “ -->
                                      <span v-for="(item, i) in hotelInfo.hotelscoreRemark" :key="i" v-if="i === 0" v-html="getLanguageHtml(item, 'hotelscoreRemark')" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 80%;height: 100%;"></span>
                                      <!-- ” -->
                                  </div>
                              </div>
                              <div class="hotel-detail-map" >
                                  <div class="hotel-detail-map-img" id="mapCodeID" @click="fullScreen($event)" v-if="hotel.longitud != '' || hotel.latitude != ''">
                                      <!-- <publicHotelMap v-if="mapMobile === 0" :longitude="hotel.longitude" :latitude="hotel.latitude"></publicHotelMap> -->
                                      <img src="https://res.roompai.com/static/img/hotelsearch/map.svg" alt="" style="width: 100%;height: 100%;cursor:pointer">
                                  </div>
                                  <div class="hotel-detail-map-img" v-else></div>
                                  <div class="hotel-detail-map-info">
                                      <div class="map-info map-info-fly" v-for="(item, i) in hotelDistance" :key="i">
                                          <div class="map-info-flag">
                                            <img :src="item.imgUrl" alt="">
                                            <span v-html="getLanguageHtml(item,'distince_from')"></span>
                                          </div>
                                          <div class="map-info-data">
                                              <span style="color:#5392F9">{{item.absolute_distince}}</span> {{$t('kilometre')}}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="hotel-detail-device-around-division">
                            <img src="/static/img/hotelsearch/division.svg" alt="">
                          </div>
                          <div class="hotel-detail-device-around">
                              <div class="device-around-class">
                                  <div class="hotel-detail-device">
                                      <div class="hotel-detail-device-line"  v-for="(item, i) in hotelFacility" :key="i">
                                          <img :src="item.imgUrl" alt="">
                                          <span v-html="getLanguageHtml(item,'facility_value')" :title="getLanguageHtml(item,'facility_value')"></span>
                                      </div>
                                      <div class="hotel-detail-device-line more-line" @click="anchorJumpLine('hotel-facilities')">
                                          {{$t('seeallFacilities')}}
                                      </div>
                                  </div>
                                  <div class="hotel-detail-around">
                                      <div class="hotel-detail-around-line first-line" v-html="$t('whatNearby')">
                                      </div>
                                      <div class="hotel-detail-around-line" v-for="(item, t) in travelAround" :key="t">
                                          <img src="https://res.roompai.com/static/img/hotelsearch/explore-addr.png" alt="">
                                          <span v-html="getLanguageHtml(item.desc,'desc')" :title="getLanguageHtml(item.desc,'desc')"></span>
                                          <span class="around-line-mileage" v-html="getLanguageHtml(item.time,'time')"></span>
                                      </div>
                                      <div class="hotel-detail-around-line more-line" @click="anchorJumpLine('hotel-overview')">
                                          {{$t('seeMoreDetails')}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                    <!-- 查看更多图片 -->
                    <div ref="seeMorePictures" class="seeMorePictures">
                        <div class="pricturesMask" @click="seeMorePicturesHide($event)"></div>
                        <div class="morePrictures">
                          <div class="morePricturesImg">
                            <div class="morePricturesLeft">
                                <span class="firstSpan" @click="prevImgShow">
                                  <img src="/static/img/hotelsearch/showImgLeft.png" alt="">
                                </span>
                                <img :src="hotelImg['0']['url']" ref="morePricturesMax" data-index="0" alt="">
                                <span class="lastSpan" @click="nextImgShow">
                                  <img src="/static/img/hotelsearch/showImgRight.png" alt="">
                                </span>
                            </div>
                            <div class="morePricturesRight" >
                              <div class="morePricturesRightImg" v-for="item in hotelImg" :key="item.id">
                                <img :src="item.url"  alt="" :dataIndex="item.id" ref="currentPictures">
                                <div ref="currentPicturesDiv" @click="curImgShow($event)" :dataIndex="item.id"></div>
                              </div>
                            </div>
                          </div>
                          <div class="closeRight">
                              <span @click="seeMorePicturesHide($event)">×</span>
                          </div>
                        </div>
                    </div>
                    <!-- 酒店图片设施 结束 -->
                  </el-card>
                  </template>
                </el-skeleton>
              </div>
              <div class="clearBoth parent-price-clear" v-if="common.isMobile() === false"></div>

              <div class="hotel-detail-info hotel-detail-info-mobile">
                <el-skeleton animated :loading="hotelShow">
                  <template slot="template">
                    <div class="hotel-detail-describe ">
                        <div class="hotel-detail-img" style="height:225px;position: relative;">
                          <div class="thumb-example"><el-skeleton-item variant="text" style="width: 100%;height: 100%;"/></div>
                        </div>
                        <div class="clearBoth hotel-room-clear"></div>
                        <!-- 酒店名称地址 开始 -->
                        <div class="hotel-detail-data">
                            <div class="hotel-detail-name">
                              <div class="hotel-detail-hotel-name">
                                <el-skeleton-item variant="text"/>
                                <el-skeleton-item variant="text"/>
                              </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="hotel-detail-evaluate">
                                <div class="hotel-detail-star"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                <div class="hotel-detail-score-all"><el-skeleton-item variant="text" style="width: 160px;"/></div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="">
                            </div>
                            <div class="hotel-detail-addr-map">
                                <div class="hotel-detail-evaluate-map">
                                    <div class="hotel-detail-map">
                                        <div class="hotel-detail-map-img">
                                          <el-skeleton-item variant="text" style="width: 100%;height: 100%;"/>
                                        </div>
                                        <div class="hotel-detail-map-info">
                                            <div class="map-info map-info-fly" v-for="index in 3" :key="index">
                                              <el-skeleton-item variant="text" style="margin: 7px 0px;"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearBoth"></div>
                                <div class="hotel-detail-addr"><el-skeleton-item variant="text"/></div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                            <div class="clearBoth"></div>
                            <div class="hotel-detail-around">
                                <div class="hotel-detail-around-line first-line">
                                  <el-skeleton-item variant="text" style="width: 50px;"/>
                                  <el-skeleton-item variant="text" class="around-line-mileage more-around" style="width: 75px;"/>
                                </div>
                                <div class="hotel-detail-around-line" v-for="index in 4" :key="index">
                                  <el-skeleton-item variant="text" style="width: 40%;float: left;padding-left: 0px;"/>
                                  <el-skeleton-item variant="text" style="width: 40%;float: right;" class="around-line-mileage"/>
                                </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                            <!-- 人气设施 -->
                            <div class="hotel-detail-around">
                                <div class="hotel-detail-around-line first-line" >
                                  <el-skeleton-item variant="text" style="width: 100px;"/>
                                  <el-skeleton-item variant="text"  class="around-line-mileage more-around" style="width: 160px;"/>
                                </div>
                            </div>
                            <div class="hotel-detail-around-all">
                                <div class="hotel-detail-around-one">
                                    <div class="hotel-detail-device-line" style="width: 23%;" v-for="index in 4" :key="index">
                                      <el-skeleton-item variant="text" style="height: 54px; width: 100%;"/>
                                    </div>
                                </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                        </div>
                        <div class="clearBoth "></div>
                    </div>
                    <!-- 酒店图片设施 结束 -->
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                      <div class="hotel-detail-describe ">
                        <div class="hotel-detail-img" v-if="ispublic === false">
                            <div class="thumb-example">
                              <div class="hotel-detail-love">
                                <svg @click="collect(hotel.hotelid, hotelCollect.islike)" :class="'hotel-like-'+hotelCollect.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0" style="width: 35px;position: absolute;top: 135px;z-index: 10;right: 10px;">
                                  <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                                </svg>
                              </div>
                              <!-- swiper1 -->
                              <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop" >
                                  <swiper-slide class="slide-1" v-for="item in hotelMobileImg" :key="item.id">
                                    <img :src="item.url" style="height:225px;width:100%" alt="" />
                                  </swiper-slide>
                                  <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                                  <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                              </swiper>
                              <!-- swiper2 Thumbs -->
                              <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                                <swiper-slide class="slide"  v-for="item in hotelMobileImg" :key="item.id" >
                                  <img style="width:100%;height:100%;" :src="item.url" alt="" />
                                </swiper-slide>
                              </swiper>
                            </div>
                        </div>
                        <div class="hotel-detail-img" style="height:225px;position: relative;" v-else>
                          <div class="thumb-example">
                              <swiper class="swiper" style="width:100%; height:100%;" :options="swiperOptionTop" ref="swiperTop" >
                                  <swiper-slide class="slide-1" v-for="item in hotelMobileImg" :key="item.id">
                                    <img :src="item.url" style="height:100%;width:100%" alt="" />
                                  </swiper-slide>
                              </swiper>
                            </div>
                            <div style="position: absolute; top: 0; background: rgba(0, 0, 0, 0.4); width: 100%; height: 225px; border-radius: 4px; z-index: 100;">
                              <div style="margin: 30px; color: white; font-weight: 545;">{{$t('nopic')}}</div>
                            </div>
                        </div>
                        <div class="clearBoth hotel-room-clear"></div>
                        <!-- 酒店名称地址 开始 -->
                        <div class="hotel-detail-data">
                            <div class="hotel-detail-name">
                              <div class="hotel-detail-hotel-name">
                                <span v-html="getLanguageHtml(hotel,'hotelname')"></span>
                              </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="hotel-detail-evaluate">
                                <div class="hotel-detail-star">
                                  <b style="margin-right: 3px;" v-for="val in hotelInfo.star" :key="val">
                                    <img style="width:15px;height:15px;" src="/static/img/star.png">
                                  </b>
                                  <b style="margin-left: -3px;" v-if="hotelInfo.star_decimal === 1">
                                    <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                                  </b>
                                </div>
                                <div class="hotel-detail-score-all">
                                  <div class="hotel-detail-score" style="float:left;font-size:12px">
                                      {{hotelInfo.hotelscore}}
                                      <b v-html="getLanguageHtml(hotelInfo.hotelscoreStr, 'hotelscoreStr')" style="margin: 0px 8px 0px 0px;padding: 2px 0px 2px 0px;-ms-flex-wrap: nowrap;flex-wrap: nowrap;-webkit-box-align: center;-ms-flex-align: center;align-items: center;display: inline-block;border-radius: 4px;"></b>
                                  </div>
                                  <div class="hotel-detail-quality-evaluate" style="float:right">
                                      <span v-for="(item, i) in hotelInfo.hotelscoreRemark" :key="i" v-html="getLanguageHtml(item, 'hotelscoreRemark')" class="hotel-detail-quality-all" :class="[{'hotel-detail-quality-hone': hotelSorceRemark === 0}, {'hotel-detail-quality-green': hotelSorceRemark === 1}, {'hotel-detail-quality-cheng': hotelSorceRemark === 2}, {'hotel-detail-quality-qing': hotelSorceRemark === 3}, {'hotel-detail-quality-blue': hotelSorceRemark === 4}, {'hotel-detail-quality-zi': hotelSorceRemark === 5}, {'hotel-detail-quality-fen': hotelSorceRemark === 6}]"></span>
                                  </div>
                                </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="">
                            </div>
                            <div class="hotel-detail-addr-map">
                                <div class="hotel-detail-evaluate-map">
                                    <div class="hotel-detail-map">
                                        <div class="hotel-detail-map-img" @click="fullScreen($event)" v-if="hotel.longitud != '' || hotel.latitude != ''">
                                            <!-- <publicHotelMap v-if="mapMobile === 1"></publicHotelMap> -->
                                            <img src="https://res.roompai.com/static/img/hotelsearch/map.svg" alt="" style="width: 100%;height: 100%;cursor:pointer">
                                        </div>
                                        <div class="hotel-detail-map-img" v-else></div>
                                        <div class="hotel-detail-map-info">
                                            <div class="map-info map-info-fly" v-for="(item, i) in hotelDistance" :key="i">
                                                <div class="map-info-flag">
                                                  <img :src="item.imgUrl" alt="">
                                                  <el-tooltip effect="dark" placement="top-start" :show-overflow-tooltip="true">
                                                    <div slot="content" v-html="getLanguageHtml(item,'distince_from')"></div>
                                                    <span v-if="language === 'en'">{{item.distince_from_en}}</span>
                                                    <span v-else>{{item.distince_from_zh}}</span>
                                                  </el-tooltip>
                                                  <!-- <span v-html="getLanguageHtml(item,'distince_from')"></span> -->
                                                </div>
                                                <div class="map-info-data">
                                                    <span style="color:#5392F9">{{item.absolute_distince}}</span> {{$t('kilometre')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearBoth"></div>
                                <div class="hotel-detail-addr">
                                    <img src="/static/img/hotelsearch/hotel-addr-periphery.png" alt="">
                                    <span v-html="getLanguageHtml(hotel,'hoteladdr')"></span>
                                </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                            <div class="clearBoth"></div>
                            <div class="hotel-detail-around" v-if="travelAround !== undefined && travelAround.length > 0">
                                <div class="hotel-detail-around-line first-line" @click="whatNearbyShow = true">
                                    <span v-html="$t('whatNearby')" style="line-height: normal;"></span>
                                    <span class="around-line-mileage more-around" style="line-height: normal;"> {{$t('seeMoreDetails')}} </span>
                                </div>
                                <div class="hotel-detail-around-line" v-for="(item, t) in travelAround" :key="t" :class="{'hotel-detail-around-line-last': t === 3}">
                                    <img src="/static/img/hotelsearch/hotel-addr-periphery.png" alt="">
                                    <span v-html="getLanguageHtml(item.desc,'desc')"></span>
                                    <span class="around-line-mileage" v-html="getLanguageHtml(item.time,'time')"></span>
                                </div>
                            </div>
                            <div class="clearBoth" v-if="travelAround !== undefined && travelAround.length > 0"></div>
                            <div class="demarcation-line" style="width:100%" v-if="travelAround !== undefined && travelAround.length > 0">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                            <!-- 人气设施 -->
                            <div class="hotel-detail-around">
                                <div class="hotel-detail-around-line first-line" @click="facilitiesShow = true" >
                                    <span v-html="$t('facilities')"  style="line-height: normal;"></span>
                                    <span class="around-line-mileage more-around" style="line-height: normal;"> {{$t('seeallFacilities')}} </span>
                                </div>
                            </div>
                            <div class="hotel-detail-around-all">
                                <div class="hotel-detail-around-one">
                                    <div class="hotel-detail-device-line"  v-for="(item, i) in hotelFacility" :key="i">
                                        <div><img :src="item.imgUrl" alt=""></div>
                                        <div><span v-html="getLanguageHtml(item,'facility_value')"></span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearBoth"></div>
                            <div class="demarcation-line" style="width:100%">
                              <img src="/static/img/hotelsearch/division.svg" alt="" style="width:100%">
                            </div>
                        </div>
                        <div class="clearBoth "></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
              </div>
              <div class="clearBoth" ref="roominfo"></div>

              <!-- 酒店筛选 开始  -->
              <div class="hotel-room-desc-seach hotel-room-seach-pc" :style="hotelRoomSearchPcFixedPlaceholder" ></div>
              <el-skeleton animated :loading="!isPriceShow">
                <template slot="template">
                  <div class="hotel-room-desc-seach hotel-room-seach-pc" id="hotel-roomname">
                    <div class="hotel-room-title-left">
                        <div class="hotel-room-title"><el-skeleton-item variant="text" style="width: 60px;height: 20px;margin-top: 10px;" /></div>
                        <div class="hotel-room-title"><el-skeleton-item variant="text" style="width: 60px;height: 20px;margin-top: 10px;" /></div>
                        <div class="hotel-room-title"><el-skeleton-item variant="text" style="width: 60px;height: 20px;margin-top: 10px;" /></div>
                        <div class="hotel-room-title"><el-skeleton-item variant="text" style="width: 60px;height: 20px;margin-top: 10px;" /></div>
                    </div>
                    <div class="hotel-room-title-right">
                      <el-skeleton-item variant="text" style="width: 100px;height: 20px;margin: 10px 30px 0px 20px;" />
                      <el-skeleton-item variant="text" style="width: 100px;height: 20px;margin: 10px 30px 0px 20px;" />
                    </div>
                  </div>
                  <div class="clearBoth"></div>
                  <div class="hotel-room-seach-mobile">
                    <div class="hotel-room-title-right">
                      <el-skeleton-item variant="text" style="width: 100px;height: 20px; margin-bottom: 10px;" />
                      <el-skeleton-item variant="text" style="width: 100px;height: 20px; margin-bottom: 10px;" />
                    </div>
                  </div>
                </template>
                <template>
                  <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                    <div class="hotel-room-desc-seach hotel-room-seach-pc" id="hotel-roomname" :style="hotelRoomSearchPcFixed">
                      <div class="hotel-room-title-left">
                          <div class="hotel-room-title" :class="[{'hotel-room-active': anchorJumpStatus==='hotel-roomname'}]" @click="anchorJumpLine('hotel-roomname')">{{$t('roomName')}}</div>
                          <div class="hotel-room-title" :class="[{'hotel-room-active': anchorJumpStatus==='hotel-overview'}]" @click="anchorJumpLine('hotel-overview')">{{$t('overview')}}</div>
                          <div class="hotel-room-title" :class="[{'hotel-room-active': anchorJumpStatus==='hotel-policies'}]" @click="anchorJumpLine('hotel-policies')" v-if="hotelPolicy.import_notice_en!='' || hotelPolicy.city_notice_en!='' || hotelPolicy.child_notice_en!='' || hotelPolicy.pet_notice_en!='' || hotelPolicy.agelimit_notice_en!='' || hotelPolicy.checkin_notice_en!='' || hotelPolicy.other_service_en!='' || hotelPolicy.breakfast_notice_en!=''">{{$t('policies')}}</div>
                          <div class="hotel-room-title" :class="[{'hotel-room-active': anchorJumpStatus==='hotel-facilities'}]" @click="anchorJumpLine('hotel-facilities')">{{$t('facilities')}}</div>
                      </div>
                      <div class="hotel-room-title-right">
                          <div class="hotel-room-select" style="border: solid 1px #DCDFE2;border-top: none;border-bottom: none;padding: 0 0 0 20px;">
                            <span style="font-size: 14px;color: #606266;font-weight: 500;padding-right: -7px;">{{$t('mealType')}}</span>
                             <el-select v-model="mealType" class="meal-select" :placeholder="$t('mealType')" @change="checkedBox('breakfast')" style="width: auto;">
                                <el-option
                                  v-for="item in mealOptions"
                                  :key="item.value"
                                  :label="$t(item.label)"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                          </div>
                          <div class="hotel-room-button" :style="checked_cancel ? 'background:#5392F9;color:#fff;border: solid 1px #5392F9;' : ''">
                             <el-checkbox v-model="checked_cancel" @change="checkedBox('cancel')" :style="checked_cancel ? 'background:#5392F9;color:#fff;' : ''"> {{$t('freeCancellation')}} </el-checkbox>
                          </div>
                      </div>
                    </div>
                    <div class="clearBoth"></div>
                    <div class="hotel-room-seach-mobile">
                      <div class="hotel-room-title-right">
                          <div class="hotel-room-select hotel-room-select-mini" style="border: solid 1px #DCDFE2;padding: 0 0 0 20px;">
                             <span style="font-size: 12px;color: #606266;font-weight: 500;">{{$t('mealType')}}</span>
                             <el-select v-model="mealType" class="meal-select-mini" size="mini" :placeholder="$t('mealType')" @change="checkedBox('breakfast')" style="">
                                <el-option
                                  v-for="item in mealOptions"
                                  :key="item.value"
                                  :label="$t(item.label)"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                          </div>
                          <div class="hotel-room-button" :style="checked_cancel ? 'background:#5392F9;color:#fff;border: solid 1px #5392F9;border-bottom: none;border-top: none;' : ''">
                            <el-checkbox v-model="checked_cancel" @change="checkedBox('cancel')" :style="checked_cancel ? 'background:#5392F9;color:#fff;' : ''"> {{$t('freeCancellation')}} </el-checkbox>
                          </div>
                      </div>
                    </div>
                  </el-card>
                </template>
              </el-skeleton>
              <div class="clearBoth parent-price-clear" v-if="common.isMobile() === false"></div>
              <div v-else class="clearBoth" style="height:10px;"></div>

              <!-- 酒店房型 开始  -->
              <div class="hotel-room-empty hotel-room-price-pc" v-show="roomEmptyShow">
                <div><img src="https://res.roompai.com/static/img/hotelsearch/hotellist-no.png" class="content-empty-img"></div>
                <div class="content-empty-text">
                  <div>{{$t('sorryHaveNoRoomsAtPropertyOn')}}</div>
                  <div>
                    <span style="color:#5392F9; cursor: pointer;" @click="focusData">
                      {{$t('changeYouDates')}}
                    </span>
                    {{$t('soldOr')}}
                    <span style="color:#5392F9;cursor: pointer;" @click="selectHotelList">
                      {{$t('searchOtherHotelRoom')}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="clearBoth room-price-clear" v-show="roomEmptyShow"></div>

              <!-- PC 推荐酒店开始 -->
              <div class="hotel-room-recommend hotel-room-price-pc" v-show="roomEmptyShow">
                <div class="recommend-title" v-if="Object.keys(recommendHotelList).length !== 0">
                  {{ $t('RecommendedByNearbyHotels') }}
                </div>
                <div class="recommend-body" v-if="Object.keys(recommendHotelList).length !== 0">
                  <el-row>
                    <el-col :span="6" class="row-col" v-for="(value, key) in recommendHotelList" :key="key">
                      <el-card style="height:345px;" >
                        <div class="home-img">
                          <span style="cursor: pointer;" @click="recommendGotoDetail(value.hotelid, value.hotelname, value.search)">
                            <div class="picinfo" v-if="value.pic !== ''">
                              <img :src="value.pic" class="hotel-image">
                            </div>
                            <div class="picinfo" v-else>
                              <img :src="value.dpic" class="hotel-image">
                              <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                            </div>
                          </span>
                          <svg @click="recommendcollect(key, value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                            <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                          </svg>
                          <!-- <div :class="'home-love-'+value.islike" @click="collect(value.hotelid, value.islike)"></div> -->
                        </div>
                        <div class="hotel-infos" @click="recommendGotoDetail(value.hotelid, value.hotelname, value.search)">
                          <span class="hotel-name">
                            <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                              <span>{{value.hotelname_short}}</span>
                            </el-tooltip>
                          </span>
                          <span class="hotel-star">
                            <b style="margin-right: 3px;" v-for="n in value.star" :key="n">
                              <img style="width:15px;height:15px;" src="/static/img/star.png">
                            </b>
                            <b style="margin-left: -3px;" v-if="value.star_decimal === 1">
                              <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                            </b>
                          </span>
                          <span class="hotel-addr" v-if="language === 'en'">
                            <el-tooltip :content="value.hoteladdress" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                              <span>{{value.hoteladdress_short}}</span>
                            </el-tooltip>
                          </span>
                          <span class="hotel-addr" v-else>
                            <el-tooltip :content="value.hoteladdress_zh" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                              <span>{{value.hoteladdress_short_zh}}</span>
                            </el-tooltip>
                          </span>
                          <span class="hotel-br"></span>
                          <div class="hotel-price">
                            <span >
                              <span style="font-size:10px; font-weight:400;display: inline-block;">{{value.currency}}</span> {{value.price}}
                            </span>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="clearBoth room-price-clear" v-show="roomEmptyShow"></div>
              <div class="hotel-room-price-title hotel-room-price-pc" v-show="!roomEmptyShow">
                <el-skeleton animated :loading="!isPriceShow">
                  <template slot="template">
                    <div class="room-price-title">
                      <div class="room-title text-font-hidden"><el-skeleton-item variant="text" style="width: 60px;height: 20px; margin-top: 8px;" /></div>
                      <div class="beds-title text-font-hidden"> <el-skeleton-item variant="text" style="width: 60px;height: 20px; margin-top: 8px;" /> </div>
                      <div class="breakfast-title text-font-hidden"> <el-skeleton-item variant="text" style="width: 60px;height: 20px; margin-top: 8px;" /> </div>
                      <div class="cancel-title text-font-hidden"> <el-skeleton-item variant="text" style="width: 60px;height: 20px; margin-top: 8px;" /> </div>
                      <div class="price-title text-font-hidden"><el-skeleton-item variant="text" style="width: 60px;height: 20px; margin-top: 8px;" /></div>
                      <div class="button-title text-font-hidden"></div>
                    </div>
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                      <div class="room-price-title">
                        <div class="room-title text-font-hidden">{{$t('roomType')}}</div>
                        <!-- <div class="beds-title text-font-hidden"> {{$t('bedType')}} </div> -->
                        <div class="beds-title text-font-hidden"> {{$t('productType')}} </div>
                        <div class="breakfast-title text-font-hidden"> {{$t('breakfast')}} </div>
                        <div class="cancel-title text-font-hidden"> {{$t('cancellationPolicy')}} </div>
                        <div class="price-title text-font-hidden">{{$t('totalPrice')}}</div>
                        <div class="button-title text-font-hidden"></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
                <el-skeleton :count="3" animated :loading="!isPriceShow">
                  <template slot="template">
                    <div class="parent-room-price">
                      <el-skeleton-item variant="text" style= "width: 100%;height: 155px;margin-bottom: 20px;" />
                    </div>
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }" style="border: none; box-shadow: none;">
                      <div class="hotel-room-empty hotel-room-price-pc" v-show="noFilterResult" style="border-radius:0px 0px;margin-bottom: 20px;border-top: none;">
                        <div><img src="https://res.roompai.com/static/img/hotelsearch/hotellist-no.png" class="content-empty-img"></div>
                        <div class="content-empty-text">
                          <div>{{$t('noMatchingRooms')}}</div>
                        </div>
                      </div>
                      <div class="parent-room-price" v-for="(item,i) in roomList" :key="i" v-show="item.parentInfo.parentRoomShow === '1'">
                          <!-- 母房型 -->
                          <div class="parent-room">
                              <div class="text-font-hidden" v-html="getLanguageHtml(roomList[i], 'roomname')"></div>
                          </div>
                          <!-- 床型价格 -->
                          <div class="beds-price">
                              <div class="beds-price-line" v-for="(price,k) in item['priceInfo']" :key="k" v-show="price.selected">
                                  <div class="room-title-img" :class="[{'beds-price-line-lastimg':k + 1 === item['priceInfo'].length}]" >
                                    <div class="room-beds-img" v-if="price.imgIsShow"  @click="viewDetailShow" data-index="room-info-pc">
                                      <img :src="item['parentInfo']['url']" alt=""  data-index="room-info-pc">
                                      <div class="no-room-img text-font-hidden" v-if="item['parentInfo']['urlInfo'] === 0"  data-index="room-info-pc">{{$t('nopic')}}</div>
                                      <div class="text-font-hidden" v-else  data-index="room-info-pc">{{$t('viewDetails')}}</div>
                                    </div>
                                    <div class="room-info-desc" data-index="room-info-pc" v-if="price.imgIsShow" style="display:none">
                                      <div class="room-info"  v-if="item['parentInfo']['roomarea'] !== ''"  data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/roomarea.png" class="room-info-img" alt="" data-index="room-info-pc">
                                        <div class="room-info-text" data-index="room-info-pc">
                                          {{$t('area')}}：
                                          <span v-html="getLanguageHtml(item['parentInfo']['roomarea'], 'roomarea')" data-index="room-info-pc"></span>
                                        </div>
                                      </div>
                                      <div class="room-info"  v-if="item['parentInfo']['is_window'] !== ''"  data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/window.png" class="room-info-img" alt=""  data-index="room-info-pc">
                                        <div class="room-info-text"  data-index="room-info-pc">
                                          {{$t('window')}}：<span v-html="getLanguageHtml(item['parentInfo']['is_window'], 'window')" data-index="room-info-pc"></span>
                                        </div>
                                      </div>
                                      <div class="room-info" v-if="item['parentInfo']['scenery']!=null && item['parentInfo']['scenery']!=''" data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/scenery.png" class="room-info-img" alt=""  data-index="room-info-pc">
                                        <div class="room-info-text" data-index="room-info-pc">
                                          {{$t('scenery')}}：<span v-html="item['parentInfo']['scenery']" data-index="room-info-pc"></span>
                                        </div>
                                      </div>
                                      <div class="room-info" v-if="item['parentInfo']['maxinum'] !== '0'" data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/maxCheck.png" class="room-info-img" alt="" data-index="room-info-pc">
                                        <div class="room-info-text" data-index="room-info-pc">
                                          {{$t('maximum')}}：<span v-html="item['parentInfo']['maxinum']"  data-index="room-info-pc"></span>
                                        </div>
                                      </div>
                                      <div class="room-info" v-if="item['parentInfo']['floor'] !== '' && item['parentInfo']['showInfoNum'] < 6" data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/floor.png" class="room-info-img" alt=""  data-index="room-info-pc">
                                        <div class="room-info-text" data-index="room-info-pc">
                                          {{$t('floor')}}：
                                          <span v-html="item['parentInfo']['floor']"  data-index="room-info-pc"></span>
                                        </div>
                                      </div>
                                      <div class="room-bed-info text-font-hidden" data-index="room-info-pc">
                                        <img src="https://res.roompai.com/static/img/hotelsearch/beds.png" class="room-info-img" alt=""  data-index="room-info-pc">
                                        <div class="room-info-text" data-index="room-info-pc">
                                        <!-- <el-tooltip class="item" effect="dark" :content="getLanguageHtml(item['parentInfo']['beds'], 'bed')" placement="top-start">-->
                                          <span  data-index="room-info-pc">
                                            {{$t('bedType')}}：
                                            <span v-html="getLanguageHtml(item['parentInfo']['beds'], 'bed')"  data-index="room-info-pc"></span>
                                          </span>
                                        <!-- </el-tooltip> -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="beds-title-data text-font-hidden"> {{price.bed_str}} </div> -->
                                  <div class="beds-title-data" v-if="item['parentInfo'].name_en === 'Others'">
                                    <el-tooltip class="others-room green-color" effect="dark" :content="getLanguageHtml(price, 'sonroomname')" placement="top-start" v-if="common.languageSet(this) === 'en'">
                                      <span>{{price.name}}</span>
                                    </el-tooltip>
                                    <el-tooltip class="others-room green-color" effect="dark" :content="getLanguageHtml(price, 'sonroomname')" placement="top-start" v-else>
                                      <span>{{price.name_cn}} <a v-if="price.name_cn !== ''">(</a>{{price.name}}<a v-if="price.name_cn !== ''">)</a></span>
                                    </el-tooltip>
                                    <div style="height: 25px;line-height: 25px;">{{$t('instantConfirmation')}}</div>
                                  </div>
                                  <div class="beds-title-data text-font-hidden" v-else>
                                    {{$t('instantConfirmation')}}
                                  </div>
                                  <div class="breakfast-title-data text-font-hidden">
                                      <span v-html="getLanguageHtml(price.breakfast,'breakfast')" :class="[{'breakfastColor':price.breakfast === 'freeBreakfast'}]"></span>
                                  </div>
                                  <div class="cancel-title-data">
                                    <!--<p class="p-margin-top-bottom-15px"></p>-->
                                    <span v-if="price.fundable !== 'nonFefundable'" class="underline-dashed fontColorGreen">
                                      <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="getLanguageHtml(price, 'room-cancel')" placement="top-start" v-if="common.languageSet(this) === 'zh'">
                                        <span>{{price.fundableDate.year}}年{{price.fundableDate.month}}月{{price.fundableDate.day}}日{{$t('dateFreeCancellation')}}</span>
                                      </el-tooltip>
                                      <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="getLanguageHtml(price, 'room-cancel')" placement="top-start"  v-if="common.languageSet(this) === 'en'">
                                        <span>{{$t('dateFreeCancellation')}} {{price.fundableDate.Month}} {{price.fundableDate.day}}, {{price.fundableDate.year}}</span>
                                      </el-tooltip>
                                    </span>
                                    <span v-else>
                                        {{$t('nonFefundable')}}
                                    </span>
                                  </div>
                                  <div class="price-title-data">
                                    <div class="price-title-data-top">
                                      <!-- <span class="price-title-data-desc">{{$t('afterTax')}}</span> -->
                                      <span class="price-title-data-cur font-red">{{price.currency}}</span>

                                      <el-popover placement="bottom" width="350" trigger="hover" popper-class="price-title-data-cont">
                                        <div class="price-title-data-detail" style="width:100%;">
                                          <div class="price-title-data-detail-top">
                                            <div class="price-title-data-detail-center">
                                              {{$t('priceDetails')}}
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-body">
                                            <div>
                                              <!-- price -->
                                              <div class="price-title-data-detail-line">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{searchPriceData.roomcount}}{{$t('onOurSite')}} x {{searchPriceData.nightCount}}{{$t('night')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    {{price.currency}} {{price.fareTotal}}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('avgNight')}} {{price.currency}} {{price.fare}}</span>
                                                </div>
                                              </div>
                                              <!-- tax -->
                                              <div class="price-title-data-detail-line">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('taxesFees')}}</span>
                                                    <el-popover popper-class="popverText" placement="top-start" width="327" offset="99" trigger="click" v-if="language === 'en'">
                                                      <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                                                      <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                                                    </el-popover>
                                                    <el-popover popper-class="popverText" placement="top-start" width="327" offset="44" trigger="click" v-else>
                                                      <div style="font-size:8px;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                                                      <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                                                    </el-popover>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    {{price.currency}} {{price.curTax}}
                                                  </div>
                                                </div>
                                              </div>
                                              <!-- payableAtProperty -->
                                              <div class="price-title-data-detail-line" v-if="price.mandatoryFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('mandatoryFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.mandatoryFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.mandatoryFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.mandatoryTax !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('mandatoryTax')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.mandatoryTax}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.mandatoryTax !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.resortFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('resortFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.resortFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.resortFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.cityFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('cityTaxFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.cityFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.cityFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.destinationFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('destinationFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.destinationFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.destinationFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.serviceFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('serviceFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.serviceFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.serviceFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.CleaningFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('cleaningFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.CleaningFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.CleaningFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-line" v-if="price.administrativeFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('administrativeFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.administrativeFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.administrativeFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 婴儿床费 -->
                                              <div class="price-title-data-detail-line" v-if="price.cribFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('cribFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.cribFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.cribFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 婴儿床费 -->
                                              <div class="price-title-data-detail-line" v-if="price.cribFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('cribFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.cribFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.cribFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 维护费 -->
                                              <div class="price-title-data-detail-line" v-if="price.maintenanceFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('maintenanceFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.maintenanceFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.maintenanceFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 杂费 -->
                                              <div class="price-title-data-detail-line" v-if="price.miscellaneousFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('miscellaneousFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.miscellaneousFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.miscellaneousFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 其他费 -->
                                              <div class="price-title-data-detail-line" v-if="price.otherFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('otherFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.otherFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.otherFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 套餐费 -->
                                              <div class="price-title-data-detail-line" v-if="price.packageFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('packageFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.packageFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.packageFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 宠物卫生费 -->
                                              <div class="price-title-data-detail-line" v-if="price.petSanitationFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('petSanitationFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.petSanitationFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.petSanitationFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 加床费 -->
                                              <div class="price-title-data-detail-line" v-if="price.rollawayFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('rollawayFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.rollawayFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.rollawayFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 客房服务费 -->
                                              <div class="price-title-data-detail-line" v-if="price.roomServiceFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('roomServiceFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.roomServiceFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.roomServiceFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                              <!-- 附加费 -->
                                              <div class="price-title-data-detail-line" v-if="price.surchargeFee !== ''">
                                                <div class="price-title-data-detail-center">
                                                  <div class="price-title-data-detail-line-left">
                                                    <span>{{$t('surchargeFee')}}</span>
                                                  </div>
                                                  <div class="price-title-data-detail-line-right">
                                                    <span>{{price.surchargeFee}}</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="price-title-data-detail-min" v-if="price.surchargeFee !== '' && price.pay_at_hotel === true">
                                                <div class="price-title-data-detail-center font-min">
                                                  <span>{{$t('payableAtProperty')}}</span>
                                                </div>
                                              </div>
                                            </div>

                                            <!-- Total Price -->
                                            <div class="price-title-data-detail-line">
                                              <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
                                                <div class="price-title-data-detail-line-left">
                                                  <span>{{$t('totalPrice')}}</span>
                                                </div>
                                                <div class="price-title-data-detail-line-right">
                                                  {{price.currency}} {{price.totalPrice}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="price-title-data-detail-min" :class="{'price-padding': price.payPriceShow === false || price.payPriceShow === 'false'}">
                                              <div class="price-title-data-detail-center font-min">
                                                <span>{{$t('includesTaxesFees')}}</span>
                                              </div>
                                            </div>
                                            <!-- Pay Now -->
                                            <div class="price-title-data-detail-line" style="padding-bottom:20px;" v-if="price.payPriceShow === true || price.payPriceShow === 'true'">
                                              <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
                                                <div class="price-title-data-detail-line-left">
                                                  <span>{{$t('payNow')}}</span>
                                                </div>
                                                <div class="price-title-data-detail-line-right">
                                                  {{price.currency}} {{price.payPrice}}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <span slot="reference">
                                          <div style="display: inherit;">
                                            <span style="cursor:pointer;display: inline;border-bottom: dashed 1px #E12D2D;">
                                              <span class="font-red font-24-weight" v-if="source.includes('google')">{{price.totalPrice}}</span>
                                              <span class="font-red font-24-weight" v-else>{{price.payPrice}}</span>
                                            </span>
                                          </div>
                                        </span>
                                      </el-popover>
                                    </div>
                                    <div class="price-title-data-bottom">
                                      <span class="font-7F-10">{{$t('includesTaxesFees')}}</span>

                                      <span class="font-7F-10" v-if="price.hasOwnProperty('google_feed_cache')" style="margin-top: 1px;">
                                        <span style="vertical-align: text-bottom;">{{$t('googlePriceSign')}}</span>
                                        <img src="/static/img/google.png" alt="google" style="width:18px;vertical-align: text-bottom;">
                                      </span>
                                    </div>

                                  </div>
                                  <div class="button-title-data">
                                    <div class="button-title-data-reserve button-data-pc">
                                        <button @click="parentRoomBook(price)">{{$t('book')}}</button>
                                        <!--
                                        <div v-if="price.remainrooms < 3">
                                          <span class="font-12" style="color:#E12D2D">
                                            {{$t('onlyLast')}}
                                            <span>{{price.remainrooms}}</span>
                                            {{$t('hotelDetailroomCount')}}！
                                          </span>
                                        </div>
                                        <div v-else>
                                          <span class="font-12" style="color:#32A923">{{$t('limitedAvailability')}}</span>
                                        </div>
                                        -->
                                    </div>
                                    <div class="button-title-data-reserve button-data-mobile">
                                        <button @click="parentRoomBook(price)">{{$t('bookmin')}}</button>
                                    </div>
                                  </div>
                              </div>
                          </div>
                          <!-- 更多价格 -->
                          <div class="look-more" v-if="item['priceInfo'].length > 4">
                            <div>
                              {{$t('showMore')}}
                            </div>
                          </div>
                          <div class="clearBoth parent-price-clear"></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
              </div>

              <div class="hotel-room-price-mobile" v-show="roomEmptyShow">
                <div class="hotel-room-empty">
                  <div><img src="https://res.roompai.com/static/img/hotelsearch/hotellist-no.png" class="content-empty-img"></div>
                  <div class="content-empty-text">
                    <div>{{$t('sorryHaveNoRoomsAtPropertyOn')}}</div>
                    <div>
                      <span style="color:#5392F9; cursor: pointer;" @click="focusData">
                        {{$t('changeYouDates')}}
                      </span>
                      {{$t('soldOr')}}
                      <span style="color:#5392F9;cursor: pointer;" @click="selectHotelList">
                        {{$t('searchOtherHotelRoom')}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="clearBoth room-price-clear"></div>

                <div class="hotel-room-recommend" style="width: 95%;margin: 0 auto;" v-if="Object.keys(recommendHotelList).length !== 0">
                  <div class="recommend-title" style="ffont-size: 12px;text-indent: 0.2rem;border: none;border-bottom: 1px solid rgb(220, 223, 226);height: 30px;line-height: 30px;border-radius: 6px 6px 6px 6px;font-size: 12px;">
                    {{ $t('RecommendedByNearbyHotels') }}
                  </div>
                  <div class="recommend-body" style="border-radius: 6px 6px 6px 6px;">
                    <el-row>
                      <el-col :span="15" class="row-col" v-for="(value, key) in recommendHotelList" :key="key">
                        <el-card style="height:345px;" >
                          <div class="home-img">
                            <span style="cursor: pointer;"  @click="recommendGotoDetail(value.hotelid, value.hotelname, value.search)">
                              <div class="picinfo" v-if="value.pic !== ''">
                                <img :src="value.pic" class="hotel-image">
                              </div>
                              <div class="picinfo" v-else>
                                <img :src="value.dpic" class="hotel-image">
                                <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                              </div>
                            </span>
                            <svg @click="recommendcollect(key, value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                              <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                            </svg>
                            <!-- <div :class="'home-love-'+value.islike" @click="collect(value.hotelid, value.islike)"></div> -->
                          </div>
                          <div class="hotel-infos" @click="recommendGotoDetail(value.hotelid, value.hotelname, value.search)">
                            <span class="hotel-name">
                              <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                <span>{{value.hotelname_short}}</span>
                              </el-tooltip>
                            </span>
                            <span class="hotel-star">
                              <b style="margin-right: 3px;" v-for="n in value.star" :key="n">
                                <img style="width:15px;height:15px;" src="/static/img/star.png">
                              </b>
                              <b style="margin-left: -3px;" v-if="value.star_decimal === 1">
                                <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                              </b>
                            </span>
                            <span class="hotel-addr" v-if="language === 'en'">
                              <el-tooltip :content="value.hoteladdress" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                <span>{{value.hoteladdress_short}}</span>
                              </el-tooltip>
                            </span>
                            <span class="hotel-addr" v-else>
                              <el-tooltip :content="value.hoteladdress_zh" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                <span>{{value.hoteladdress_short_zh}}</span>
                              </el-tooltip>
                            </span>
                            <span class="hotel-br"></span>
                            <div class="hotel-price">
                              <span >
                                <span style="font-size:10px; font-weight:400;display: inline-block;">{{value.currency}}</span> {{value.price}}
                              </span>
                            </div>
                          </div>
                        </el-card>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="clearBoth room-price-clear"></div>
              </div>
              <div class="hotel-room-price-title hotel-room-price-mobile">
                <el-skeleton :count="5" animated :loading="!isPriceShow">
                  <template slot="template">
                    <el-skeleton-item variant="text" style="width: 95%; margin: 0 2.5%; height: 130px; margin-bottom: 10px;" />
                  </template>
                  <template>
                    <div class="hotel-room-empty hotel-room-price-mobile" v-show="noFilterResult" style="border-radius:0px 0px;margin-bottom: 20px;border-top: none; text-align: center;">
                      <div><img src="https://res.roompai.com/static/img/hotelsearch/hotellist-no.png" class="content-empty-img"></div>
                      <div class="content-empty-text">
                        <div>{{$t('noMatchingRooms')}}</div>
                      </div>
                    </div>
                    <el-card class="box-card parent-room-price" v-for="(item, i) in roomList" :key="i" v-show="item.parentInfo.parentRoomShow === '1'">
                      <div class="parent-room-price-info" :class="[{'parent-room-price-active': mobileRoomPrice[i] === true}]" @click="mobileRoomShow(i)">
                        <div class="parent-room-price-info-center">
                          <div class="parent-room-price-left">
                            <div class="parent-room-price-left-top">
                              <div style="padding-top: 10px;" v-html="getLanguageHtml(roomList[i], 'roomname')"></div>
                            </div>
                            <div class="parent-room-price-left-bottom">
                              <div class="parent-room-price-left-conf" v-if="item['parentInfo']['roomarea'] !== ''" v-html="getLanguageHtml(item['parentInfo']['roomarea'], 'roomarea')"></div>
                              <div class="parent-room-price-left-conf" v-if="item['parentInfo']['is_window'] !== ''" v-html="getLanguageHtml(item['parentInfo']['is_window'], 'window')"></div>
                              <div class="parent-room-price-left-conf" v-if="item['parentInfo']['scenery'] !== null"  v-html="item['parentInfo']['scenery']"></div>
                              <div class="parent-room-price-left-conf" v-if="item['parentInfo']['maxinum'] !== '0'"  v-html="getLanguageHtml(item['parentInfo'], 'maxinum')"></div>
                              <div class="parent-room-price-left-conf" v-if="item['parentInfo']['floor'] !== ''"  v-html="getLanguageHtml(item['parentInfo'], 'floor')"></div>
                            </div>
                            <div class="parent-room-price-left-bottom">
                              <div class="parent-room-price-left-conf-bed" v-html="getLanguageHtml(item['parentInfo']['beds'], 'bed')"></div>
                            </div>
                          </div>
                          <div class="parent-room-price-right">
                            <div class="parent-room-price-right-top"><img v-if="item['parentInfo']['imgStatus'] === 1" :src="item['parentInfo']['url']" alt="" @click.stop="hotelPriceRoomImgShow = true; hotelPriceRoom = item['parentInfo'];" class="no-default-img"><div v-else class="default-img"></div></div>
                            <div class="parent-room-price-right-center">
                              <span class="hotelmoney" style="display: inherit;">
                                <span class="currency-text">{{item['parentInfo']['currency']}}</span>
                                <span class="font-red font-24-weight" v-if="source.includes('google')">{{item['parentInfo']['totalPrice']}}</span>
                                <span class="font-red font-24-weight" v-else>{{item['parentInfo']['payPrice']}}</span>
                              </span>
                              <!-- <span style="font-size: 12px;font-weight: 350;color: #999999;display: inherit;">{{$t('afterTax')}}</span> -->
                            </div>
                            <!--
                            <div class="pay-at-property-div" v-if="item.parentInfo.payAtPropertyStr !== ''">
                              <span class="pay-at-property-span hotelmoney" style="display: inherit;"><span class="currency-text">{{item['parentInfo']['currency']}}</span>{{item['parentInfo']['curPrice']}}</span>
                              <span style="font-size: 12px;font-weight: 350;color: #999999;display: inherit;">{{$t('afterTax')}}</span>
                              <span class="pay-at-property-span font-7F-10" style="height: 30%;">+ {{item.parentInfo.payAtPropertyStr}} {{$t('taxesAndCharges')}}</span>
                            </div>
                            -->
                            <div class="parent-room-price-right-bottom">
                              <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobileRoomPrice[i] === false">
                              <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobileRoomPrice[i] === true">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="parent-room-price-beds" v-if="mobileRoomPrice[i]">
                        <div class="room-beds-price-line" v-for="(price,k) in item['priceInfo']" :key="k" v-show="price.selected">
                          <div class="clearBoth hotel-room-20"></div>
                          <div class="room-beds-line" v-if="item['parentInfo'].name_en === 'Others'">
                            <div class="text-font-hidden font-size-14 margin-auto-98" v-if="language === 'en'">{{price.name}}</div>
                            <div class="text-font-hidden font-size-14 margin-auto-98" v-else>{{price.name_cn}} <a v-if="price.name_cn !== ''">(</a>{{price.name}}<a v-if="price.name_cn !== ''">)</a></div>
                          </div>
                          <div class="room-beds-line">
                            <div class="text-font-hidden font-size-14 margin-auto-98">
                              <span v-html="getLanguageHtml(price.breakfast,'breakfast')" :class="[{'breakfastColor':price.breakfast === 'freeBreakfast'}]"></span>
                              <span style="float: right;" v-if="price.hasOwnProperty('google_feed_cache')">
                                <span style="vertical-align: text-bottom;">{{$t('googlePriceSign')}}</span>
                                <img src="/static/img/google.png" alt="google" style="width:18px;vertical-align: text-bottom;">
                              </span>
                            </div>
                          </div>
                          <div class="room-beds-line"><div class="font-size-14 margin-auto-98"><span v-if="price.fundable !== 'nonFefundable'" class="underline-dashed fontColorGreen"><el-tooltip class="item cancel-title-data-cont" effect="dark" placement="top-start" :show-overflow-tooltip="true"><div slot="content" v-html="getLanguageHtml(price, 'room-cancel')"></div><span v-if="common.languageSet(this) === 'zh'">{{price.fundableDate.year}}年{{price.fundableDate.month}}月{{price.fundableDate.day}}日{{$t('dateFreeCancellation')}}</span><span v-else>{{$t('dateFreeCancellation')}} {{price.fundableDate.Month}} {{price.fundableDate.day}}, {{price.fundableDate.year}}</span></el-tooltip></span><span v-else>{{$t('nonFefundable')}}</span></div></div>
                          <div class="room-beds-line"><div class="text-font-hidden font-size-12 margin-auto-98">{{$t('instantConfirmation')}}</div></div>
                          <div class="room-beds-line-price">
                            <div class="font-size-24 margin-auto-98">
                              <!-- <span class="beds-line-price font-red font-24-weight">
                                <span class="font-weight-100 font-12 font-fimily-regular">{{price.currency}}</span>
                                <span class="font-fimily-semibold">{{price.curPrice}}</span>
                              </span> -->
                              <div class="room-beds-line-price-info" style="width:65%;" @click="selectRoomPriceDetail(price)">
                                <!--
                                <span class="hotelmoney beds-line-price"><span class="currency-text">{{price.currency}}</span><span style="border-bottom: 1px dashed rgb(225, 45, 45);cursor: pointer;">{{price.curPrice}}</span><span class="currency-text" style="margin-left:5px;color: #7F7F7F;">{{$t('afterTax')}}</span></span>
                                -->
                                <span class="font-red currency-text">{{price.currency}}</span>
                                <span style="cursor:pointer;display: inline;border-bottom: dashed 1px #E12D2D;">
                                  <span class="font-red font-24-weight" v-if="source.includes('google')">{{price.totalPrice}}</span>
                                  <span class="font-red font-24-weight" v-else>{{price.payPrice}}</span>
                                </span>
                              </div>
                              <!--
                              <div class="room-beds-line-price-info" style="width:65%;" v-if="price.payAtPropertyStr !== ''">
                                <span class="hotelmoney beds-line-price" style="display: block;line-height: 30px;height: 29px;float: unset;"><span class="currency-text">{{price.currency}}</span>{{price.curPrice}}<span class="currency-text" style="margin-left:5px;color: #7F7F7F;">{{$t('afterTax')}}</span></span>
                                <span class="pay-at-property-span" style="font-size: 10px;color: #7F7F7F;height: 15px;line-height: 10px;display: block;float: unset;">+ {{price.payAtPropertyStr}} {{$t('taxesAndCharges')}}</span>
                              </div>
                              -->
                              <div class="room-beds-line-price-info" style="width:35%;">
                                <span class="beds-line-button">
                                  <button @click="parentRoomBook(price)">{{$t('book')}}</button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clearBoth"></div>
                    </el-card>
                  </template>
                </el-skeleton>
              </div>
              <div class="clearBoth"></div>

              <div class="hotel-room-price-mobile">
                <div class="hotel-info-hotelRelated">{{$t('hotelRelated')}}</div>
              </div>

              <!-- 概览 -->
              <div class="hotel-overview hotel-detail-info-pc" id="hotel-overview">
                  <div class="overview-title">
                      {{$t('overview')}}
                  </div>
                  <div class="overview-body">
                    <div class="overview-center">
                      <div class="overview-body-line">
                          <div v-if="hotelInfo.open_time !== '' && hotelInfo.open_time !== '0'"><span>{{$t('opened')}}：</span> {{hotelInfo.open_time}}</div>
                          <div v-if="hotelInfo.roominventry > 0"><span>{{$t('roomNumber')}}：</span> {{hotelInfo.roominventry}}</div>
                          <div v-if="hotelInfo.telphone !== ''"><span>{{$t('telephone')}}：</span> {{hotelInfo.telphone}}</div>
                      </div>
                      <div class="clearBoth"></div>
                      <div class="overview-body-desc" v-if="hotelInfo.hotel_introduction_en !== ''">
                        <span v-html="getLanguageHtml(hotelInfo,'hotel_introduction')"></span>
                      </div>
                      <div class="clearBoth hotel-height15"></div>
                      <div class="overview-body-addr" v-if="hotelInfo.hotel_location_en !== ''">
                          <div><span>{{$t('hotelAddress')}}</span></div>
                          <div v-html="getLanguageHtml(hotelInfo,'hotel_location')"></div>
                      </div>
                      <div class="overview-body-feature" v-if="hotelInfo.room_features_en !== ''">
                          <div><span>{{$t('roomFeatures')}}</span></div>
                          <div v-html="getLanguageHtml(hotelInfo,'room_features')"></div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="hotel-detail-info-mobile">
                <el-card class="box-card hotel-data-info">
                  <div class="hotel-data-info-top" :class="[{'hotel-data-info-top-active': mobileOverview === true}]" @click="mobileOverview = !mobileOverview">
                    <div class="hotel-overview-text">{{$t('overview')}}</div>
                    <div class="hotel-overview-img">
                      <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobileOverview === false">
                      <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobileOverview === true">
                    </div>
                  </div>
                  <div class="hotel-data-info-bottom" v-if="mobileOverview === true">
                      <div class="overview-body-line">
                          <div v-if="hotelInfo.open_time !== '' && hotelInfo.open_time !== '0'"><span>{{$t('opened')}}：</span> {{hotelInfo.open_time}}</div>
                          <div v-if="hotelInfo.roominventry > 0"><span>{{$t('roomNumber')}}：</span> {{hotelInfo.roominventry}}</div>
                          <div v-if="hotelInfo.telphone !== ''"><span>{{$t('telephone')}}：</span> {{hotelInfo.telphone}}</div>
                      </div>
                      <div class="clearBoth"></div>
                      <div class="overview-body-desc" v-if="hotelInfo.hotel_introduction_en !== ''">
                        <span v-html="getLanguageHtml(hotelInfo,'hotel_introduction')"></span>
                      </div>
                      <div class="clearBoth hotel-height15"></div>
                      <div class="overview-body-addr" v-if="hotelInfo.hotel_location_en !== ''">
                          <div style="margin-bottom:5px"><span>{{$t('hotelAddress')}}</span></div>
                          <div v-html="getLanguageHtml(hotelInfo,'hotel_location')"></div>
                      </div>
                      <div class="overview-body-feature" v-if="hotelInfo.room_features_en !== ''">
                          <div style="margin-bottom:5px"><span>{{$t('roomFeatures')}}</span></div>
                          <div v-html="getLanguageHtml(hotelInfo,'room_features')"></div>
                      </div>
                  </div>
                </el-card>
              </div>
              <div class="clearBoth room-price-clear"></div>

              <!-- 政策 -->
              <div class="hotel-overview hotel-detail-info-pc" id="hotel-policies" v-if="hotelPolicy.import_notice_en!='' || hotelPolicy.city_notice_en!='' || hotelPolicy.child_notice_en!='' || hotelPolicy.pet_notice_en!='' || hotelPolicy.agelimit_notice_en!='' || hotelPolicy.checkin_notice_en!='' || hotelPolicy.other_service_en!='' || hotelPolicy.breakfast_notice_en!=''">
                  <div class="overview-title">
                      {{$t('policies')}}
                  </div>
                  <div class="overview-body">
                      <div class="overview-instructions" v-if="hotelPolicy.import_notice_en!='' || hotelPolicy.city_notice_en!='' || hotelPolicy.child_notice_en!='' || hotelPolicy.pet_notice_en!='' || hotelPolicy.agelimit_notice_en!=''">
                          <div class="overview-left">{{$t('bookingNotice')}}</div>
                          <div class="overview-right">
                              <div class="instructions-data" v-if="hotelPolicy.import_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('improtantInformation')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                      <span v-html="getLanguageHtml(hotelPolicy,'import_notice')"></span>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.city_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('cityNotice')}}</li>
                                  </div>
                                  <div class="instructions-data-cont" >
                                      <span v-html="getLanguageHtml(hotelPolicy,'city_notice')"></span>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.child_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('childrenNotice')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                      <span v-html="getLanguageHtml(hotelPolicy,'child_notice')"></span>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.pet_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('pets')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                    <span v-for="petvalue in pet_notice" :key="petvalue" style="display: block;">
                                      {{petvalue}}
                                    </span>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.agelimit_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('ageRequirements')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                      <span v-html="getLanguageHtml(hotelPolicy,'agelimit_notice')"></span>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.special_instructions_en && hotelPolicy.special_instructions_en!=''">
                                <div class="instructions-data-title">
                                  <li>{{$t('specialCheckinInstructions')}}</li>
                                </div>
                                <div class="instructions-data-cont">
                                  <span v-html="getLanguageHtml(hotelPolicy,'special_instructions')"></span>
                                </div>
                              </div>
                          </div>
                      </div>
                      <div class="overview-info" v-if="hotelPolicy.checkin_notice_en!='' || hotelPolicy.other_service_en!='' || hotelPolicy.breakfast_notice_en!=''">
                          <div class="overview-left">{{$t('practicalInformation')}}</div>
                          <div class="overview-right">
                              <div class="instructions-data" v-if="hotelPolicy.checkin_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('checkinCheckout')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                      <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'checkin_notice')"></span></p>
                                      <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'checkout_notice')"></span></p>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.other_service_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('extraService')}}</li>
                                  </div>

                                  <div class="instructions-data-cont">
                                      <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'other_service')"></span></p>
                                  </div>
                              </div>
                              <div class="instructions-data" v-if="hotelPolicy.breakfast_notice_en!=''">
                                  <div class="instructions-data-title">
                                    <li>{{$t('breakfast')}}</li>
                                  </div>
                                  <div class="instructions-data-cont">
                                      <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'breakfast_notice')"></span></p>
                                  </div>
                              </div>
                              <div class="instructions-data">
                                  <div class="instructions-data-title"></div>
                                  <div class="instructions-data-cont instructions-data-reference">
                                      <p class="p-margin-top-bottom-7px">{{$t('chargeOrDepositAboveWillBePaidHotel')}}</p>
                                      <p class="p-margin-top-bottom-7px">{{$t('amountAboveIsOnlyForYouReferenceFinalChargeByHotel')}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="clearBoth"></div>
                  </div>
              </div>
              <div class="hotel-detail-info-mobile" v-if="hotelPolicy.import_notice_en!='' || hotelPolicy.city_notice_en!='' || hotelPolicy.child_notice_en!='' || hotelPolicy.pet_notice_en!='' || hotelPolicy.agelimit_notice_en!=''">
                <el-card class="box-card hotel-data-info">
                  <div class="hotel-data-info-top" :class="[{'hotel-data-info-top-active': mobileHotelPolicy === true}]" @click="mobileHotelPolicy = !mobileHotelPolicy">
                    <div class="hotel-overview-text">{{$t('bookingNotice')}}</div>
                    <div class="hotel-overview-img">
                      <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobileHotelPolicy === false">
                      <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobileHotelPolicy === true">
                    </div>
                  </div>
                  <div class="hotel-data-info-bottom" v-if="mobileHotelPolicy === true">
                      <div class="instructions-data" v-if="hotelPolicy.import_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('improtantInformation')}}</span>
                          </div>
                          <div class="instructions-data-cont">
                              <span v-html="getLanguageHtml(hotelPolicy,'import_notice')"></span>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.city_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('cityNotice')}}</span>
                          </div>
                          <div class="instructions-data-cont2" >
                              <span v-html="getLanguageHtml(hotelPolicy,'city_notice')"></span>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.child_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('childrenNotice')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                              <span v-html="getLanguageHtml(hotelPolicy,'child_notice')"></span>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.pet_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('pets')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                            <span v-for="petvalue in pet_notice" :key="petvalue" style="display: block;">
                              {{petvalue}}
                            </span>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.agelimit_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('ageRequirements')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                              <span v-html="getLanguageHtml(hotelPolicy,'agelimit_notice')"></span>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.special_instructions_en && hotelPolicy.special_instructions_en!=''">
                        <div class="instructions-data-title">
                          <li>{{$t('specialCheckinInstructions')}}</li>
                        </div>
                        <div class="instructions-data-cont2">
                          <span v-html="getLanguageHtml(hotelPolicy,'special_instructions')"></span>
                        </div>
                      </div>
                  </div>
                </el-card>
              </div>
              <div class="clearBoth room-price-clear"></div>

              <div class="hotel-overview hotel-detail-info-pc" id="hotel-facilities">
                  <div class="overview-title">
                      {{$t('facilities')}}
                  </div>
                  <div class="overview-body">
                      <div class="overview-instructions-data" :style="{'height': hotelFacilitiesHeight}">
                          <ul>
                              <li v-for="(facilities,k) in hotelFacilities" :key="k"  :class="[{'inst-title': facilities.parent === 1, 'inst-title-top': facilities.parent === 1 && k != 0, 'inst-cont': facilities.parent !== 1}]" style="width: 84%;height: 25px;">
                                  <!-- <span v-if="facilities.parent === 1">·</span> -->
                                  <span v-if="facilities.parent === 1" style="width: 20px;height: 20px;display: inline-block; vertical-align: top;">
                                    <img alt="" :src="facilities.img" class="inst-img">
                                  </span>
                                  <span v-else style="width: 20px;height: 20px;display: inline-block;vertical-align: top;"></span>
                                  <span class="inst-text" v-html="getLanguageHtml(facilities,'facilities')" style="vertical-align: top;overflow: hidden;white-space: nowrap;display: inline-block;width: 88%;height: 100%;text-overflow: ellipsis;" v-bind:title="getLanguageHtml(facilities,'facilities')"></span>
                              </li>
                          </ul>
                      </div>
                      <div class="clearBoth"></div>
                  </div>
              </div>
              <div class="hotel-detail-info-mobile" v-if="hotelPolicy.checkin_notice_en!='' || hotelPolicy.other_service_en!='' || hotelPolicy.breakfast_notice_en!=''">
                <el-card class="box-card hotel-data-info">
                  <div class="hotel-data-info-top" :class="[{'hotel-data-info-top-active': mobilePracticalInformation === true}]" @click="mobilePracticalInformation = !mobilePracticalInformation">
                    <div class="hotel-overview-text">{{$t('practicalInformation')}}</div>
                    <div class="hotel-overview-img">
                      <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobilePracticalInformation === false">
                      <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobilePracticalInformation === true">
                    </div>
                  </div>
                  <div class="hotel-data-info-bottom" v-if="mobilePracticalInformation === true">
                      <div class="instructions-data" v-if="hotelPolicy.checkin_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('checkinCheckout')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                              <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'checkin_notice')"></span></p>
                              <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'checkout_notice')"></span></p>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.other_service_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('extraService')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                              <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'other_service')"></span></p>
                          </div>
                      </div>
                      <div class="instructions-data" v-if="hotelPolicy.breakfast_notice_en!=''">
                          <div class="instructions-data-title">
                            <span>{{$t('breakfast')}}</span>
                          </div>
                          <div class="instructions-data-cont2">
                              <p class="p-margin-top-bottom-7px"><span v-html="getLanguageHtml(hotelPolicy,'breakfast_notice')"></span></p>
                          </div>
                      </div>
                      <div class="instructions-data">
                          <div class="instructions-data-cont2 instructions-data-reference">
                              <p class="p-margin-top-bottom-7px">{{$t('chargeOrDepositAboveWillBePaidHotel')}}</p>
                              <p class="p-margin-top-bottom-7px">{{$t('amountAboveIsOnlyForYouReferenceFinalChargeByHotel')}}</p>
                          </div>
                      </div>
                  </div>
                </el-card>
              </div>
              <div class="clearBoth room-price-clear-70"></div>
              <!-- 查看房型 -->
              <div class="hotel-detail-info-mobile">
                <div class="hotel-detail-room-show">
                  <button @click="lookRoomList()">{{$t('lookRoom')}}</button>
                </div>
              </div>
          </div>
          <!-- 酒店详情 结束 -->
        </div>
        <!--搜索结果 结束-->
      </div>
      <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
  </el-main>
  <publicFooter :languageSet="language"></publicFooter>
  <publicHotelMap :longitude="hotel.longitude" :latitude="hotel.latitude" :hotel="hotel" :hotelImg="hotelImg['0']" @mapClose="mapClose" v-if="mapShow"></publicHotelMap>
  <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSold>
  <frameHotelSoldEn :frameHotelSoldEnDialog="frameHotelSoldEnDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSoldEn>
  <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold>
  <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
  <publicHotelDetailInfo :whatNearbyShow="whatNearbyShow" :travelAroundData="travelAround" @closepop="closepopEven"></publicHotelDetailInfo>
  <publicHotelDetailInfo :facilitiesShow="facilitiesShow" :hotelFacilitiesData="hotelFacilities" @closepop="closepopEven"></publicHotelDetailInfo>
  <publicHotelDetailInfo :hotelPriceRoomImgShow="hotelPriceRoomImgShow" :hotelPriceRoomData="hotelPriceRoom" @closepop="closepopEven"></publicHotelDetailInfo>
  <hotelRoomPriceDetail :hotelRoomPriceDetailDialog="hotelRoomPriceDetailDialog" :searchPriceData="searchPriceData" :priceDetailData="priceDetailData" :source="source" :language="language" @hotelRoomPriceDetailCloseFun="hotelRoomPriceDetailCloseFun"></hotelRoomPriceDetail>
  <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
  <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
  <NoPayOrderPop></NoPayOrderPop>
</el-container>
</template>

<script>
import { hotelDetail, hotelImg, hotelQuotedprice, recommendHotel, hotelPolicy, hotelFacilities, getCityId } from '@/request/hotel.js'
import { orderBookVerify } from '@/request/order.js'
import { doCollect } from '@/request/collect.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicSearchCond from '@/components/public/publicSearchCond'
import publicHotelMap from '@/components/public/publicHotelMap'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHotelSoldEn from '@/components/public/frameHotelSoldEn'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import publicHotelDetailInfo from '@/components/public/publicHotelDetailInfo'
import publicMask from '@/components/public/publicMask'
import GoogleOneTouch from '@/components/login/module/googleOneTouch'
import hotelRoomPriceDetail from '@/components/hotelsearch/hotelRoomPriceDetail'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'
import NoPayOrderPop from '@/components/order/module/NoPayOrderPop'
export default {
  name: 'HotelDetail',
  components: {
    publicFooter,
    publicHeader,
    publicSearchCond,
    publicHotelMap,
    frameHotelSold,
    frameHotelSoldEn,
    frameHomeSold,
    frameRise,
    publicHotelDetailInfo,
    publicMask,
    GoogleOneTouch,
    hotelRoomPriceDetail,
    frameChangeRoom,
    frameChangePriceAndRoom,
    NoPayOrderPop
  },
  data () {
    return {
      curPageData: 'HotelDetail',
      isFullscreen: true,
      listContentStyle: '',
      hotelRoomSearchPcFixed: '',
      hotelRoomSearchPcFixedPlaceholder: {'display': 'none'},
      hotelRoomSearchMobileFixed: '',
      isPriceShow: false,
      hotelid: '',
      screenWidth: 0,
      currencySwitch: this.common.currencySet(this),
      mapMobile: 0,
      hotel: {'hotelname': '', 'hotelname_zh': ''},
      hotelInfo: {'star': 0},
      hotelDistance: [{}, {}, {}],
      hotelImg: [{}, {}, {}],
      ispublic: false,
      hotelMobileImg: [],
      roomList: [],
      searchPriceData: {},
      hotelFacility: [{}, {}, {}, {}, {}],
      hotelCollect: {'islike': 0},
      hotelPolicy: {},
      hotelFacilities: [],
      travelAround: [],
      hotelFacilitiesHeight: '',
      a: '',
      input_region: '',
      input_date: '',
      input_person: '',
      mealType: 'any',
      mealOptions: [
        {value: 'any', label: 'mealAny'},
        {value: 'Bed and Breakfast', label: 'mealBedAndBreakfast'},
        {value: 'Room Only', label: 'mealRoomOnly'},
        {value: 'Half Board', label: 'mealHalfBoard'},
        {value: 'Lunch', label: 'mealLunch'},
        {value: 'Full Board', label: 'mealFullBoard'},
        {value: 'Dinner', label: 'mealDinner'},
        {value: 'All Inclusive', label: 'mealAllInclusive'}
      ],
      checked: '',
      checked_breakfast: false,
      noFilterResult: false,
      checked_cancel: false,
      // 轮播大图配置
      bigImg: [{url: 'https://res.roompai.com/static/img/rotation/photo.jpg', id: 0}, {url: 'https://res.roompai.com/static/img/rotation/photo1.jpg', id: 1}, {url: 'https://res.roompai.com/static/img/rotation/photo2.jpg', id: 2}, {url: 'https://res.roompai.com/static/img/rotation/photo3.jpg', id: 3}, {url: 'https://res.roompai.com/static/img/rotation/photo4.png', id: 4}, {url: 'https://res.roompai.com/static/img/rotation/photo5.jpg', id: 5}, {url: 'https://res.roompai.com/static/img/rotation/photo.jpg', id: 6}, {url: 'https://res.roompai.com/static/img/rotation/photo1.jpg', id: 7}, {url: 'https://res.roompai.com/static/img/rotation/photo2.jpg', id: 8}, {url: 'https://res.roompai.com/static/img/rotation/photo3.jpg', id: 9}, {url: 'https://res.roompai.com/static/img/rotation/photo4.png', id: 10}, {url: 'https://res.roompai.com/static/img/rotation/photo5.jpg', id: 11}],
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        zoom: {
          maxRatio: 5, // 最大倍数
          minRatio: 2, // 最小倍数
          toggle: true, // 不允许双击缩放，只允许手机端触摸缩放。
          containerClass: 'my-zoom-container' // zoom container 类名
        }
      },
      swiperOptionThumbs: {
        // loop: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        freeMode: true,
        freeModeSticky: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          snapOnRelease: true, // 如果设置为false，释放滚动条时slide不会自动贴合。
          dragSize: 30 // 设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
        },
        watchSlidesProgress: true
      },
      country: '',
      city: '',
      regions: {
        '7980': { 'id': '7980', 'type': '1', 'value': '纽约，美国', 'address': '纽约，美国', 'country': '美国', 'city': '纽约' },
        '767978': { 'id': '767978', 'type': '3', 'value': '大西洋城赌场度假酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '743455': { 'id': '743455', 'type': '3', 'value': '金块酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '438276': {'id': '438276', 'type': '3', 'value': '纽约曼哈顿时代广场酒店(The Manhattan at Times Square Hotel New York)', 'address': '纽约，美国', 'country': '美国', 'city': '纽约'}
      },
      roomEmptyShow: false, // 如果没有房型信息，则置为true,有：false
      anchorJumpStatus: 'hotel-roomname',
      frameHotelSoldDialog: false, // 酒店已售空的中文弹窗界面
      frameHotelSoldEnDialog: false, // 酒店已售空的英文弹窗界面
      frameHomeSoldDialog: false, // 本酒店其他母房型报价
      frameRiseDialog: false, // 房型涨价
      risePrice: 0, // 涨价多少钱
      mapShow: false, // 地图是否展示
      cityData: {},
      hotelRoomSearchFixedHeader: '',
      hotelRoomSearchFixedHeaderPlaceholder: '',
      hotelLogoFixed: '',
      language: this.common.languageSet(this),
      pet_notice: [],
      mobileRoomPrice: [],
      mobileOverview: false,
      mobileHotelPolicy: false,
      mobilePracticalInformation: false,
      whatNearbyShow: false,
      facilitiesShow: false,
      hotelPriceRoom: {'url': '', 'roomname': ''},
      hotelPriceRoomImgShow: false,
      hotelSorceRemark: Math.floor(Math.random() * 7),
      regionSelDetail: {},
      source: 'roompai',
      fullscreenLoading: false,
      checkIn: '',
      checkOut: '',
      region: '',
      hotelOverviewTop: 0,
      hotelPoliciesTop: 0,
      hotelfacilitiesTop: 0,
      recommendHotelList: {},
      hotelShow: true,
      hotelRoomPriceDetailDialog: false,
      priceDetailData: {},
      sameRoomInfo: '',
      frameChangeRoomDialog: false, // 报价不变，房型变更
      frameChangePriceAndRoomDialog: false, // 报价变更，房型变更
      linkid: '',
      conver: '' // 网站挽回标识
    }
  },
  beforeCreate () {
  },
  created () {
    sessionStorage.removeItem('orderUserData')
    this.hotelShow = true
    // 去掉首次google跳转过来的标识
    console.log('link', this.common.linkQuerys.linkid)
    if (this.common.linkQuerys.linkid !== undefined && this.common.linkQuerys.linkid !== null && this.common.linkQuerys.linkid !== '') {
      this.linkid = this.common.linkQuerys.linkid
      var getquery = JSON.parse(JSON.stringify(this.common.linkQuerys))
      console.log('getquery', getquery)
      delete getquery.linkid
      this.$router.replace({name: 'HotelDetail', params: {'querys': this.common.linkEncode(getquery, 'obj')}})
    }
    // 网站挽回标识
    if (this.common.linkQuerys.conver === 1 || this.common.linkQuerys.conver === '1') {
      this.conver = this.common.linkQuerys.conver
    }
    this.region = this.common.linkQuerys.region
    this.hotelid = this.common.linkQuerys.hotelid
    var time = parseInt(new Date().getTime() / 1000)
    var language = this.common.languageSet(this)
    var currency = this.common.currencySet(this)
    var sessionid = this.common.sessionidGet(this)
    var token = this.$md5('0' + this.common.lfSignKey)
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token')
    }

    var dataJson = {'hotelid': this.hotelid, 'token': token, 'time': time, 'language': language, 'currency': currency, 'sessionid': sessionid}
    var data = this.common.encryptionData(dataJson, this)
    hotelDetail(data).then(res => {
      var newQuerys = ''
      if (res.flag === '148' || res.flag === 148) {
        var cityname = res.data.hotel.cityBase.city
        // 如果酒店下线， 则跳转到酒店列表
        if (language === 'zh') {
          cityname = res.data.hotel.cityBase.city_zh
        }
        newQuerys = this.common.linkEncode({'source': this.source, 'type': 1, 'type_id': res.data.hotel.lfcityid, 'region': cityname}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'type': 1, 'type_id': res.data.hotel.lfcityid, 'region': cityname, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
        return
      }
      if (res.flag === '102') {
        // this.$router.push({name: 'notFoundPage', query: {'source': this.source}})
        newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'notFoundPage', params: {'querys': newQuerys}})
        return
      }
      // 保留选择的目的地
      var regionSel = {'value_zh': res.data.hotel.hotelname_zh ? res.data.hotel.hotelname_zh : res.data.hotel.hotelname, 'value_en': res.data.hotel.hotelname, 'type_id': 3, 'type_data_id': this.hotelid}
      this.regionSelDetail = regionSel
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      if (this.region === undefined || this.region === '') {
        if (this.language === 'zh') {
          this.region = res.data.hotel.hotelname_zh
        } else {
          this.region = res.data.hotel.hotelname
        }
      }
      this.hotel = res.data.hotel
      sessionStorage.setItem('search_hotel_location', res.data.hotel.cityBase.city) // 为了注册时记录搜索的酒店所属城市
      this.hotelInfo = res.data.hotelInfo
      this.hotelDistance = res.data.hotelDistance
      this.hotelFacility = res.data.hotelFacility
      this.hotelCollect = res.data.hotelCollect
      this.travelAround = res.data.travelAround
      this.hotelShow = false
    })

    // hotelimg
    var imgDataJson = {'hotelid': this.hotelid, 'operation': 'hotelImg', 'time': time, 'sessionid': sessionid}
    var imgData = this.common.encryptionData(imgDataJson, this)
    hotelImg(imgData).then(res => {
      this.hotelImg = res.data.hotelImg
      this.hotelMobileImg = res.data.hotelImg
      this.ispublic = res.data.ispublic
    })

    // hotelPolicy
    var policyDataJson = {'hotelid': this.hotelid, 'operation': 'hotelPolicy', 'time': time, 'sessionid': sessionid}
    var policyData = this.common.encryptionData(policyDataJson, this)
    hotelPolicy(policyData).then(res => {
      this.hotelPolicy = res.data
      if (this.language === 'zh') {
        this.pet_notice = this.hotelPolicy.pet_notice_zh_arr
      } else {
        this.pet_notice = this.hotelPolicy.pet_notice_en_arr
      }
    })

    // hotelPolicy
    var FacilitiesDataJson = {'hotelid': this.hotelid, 'operation': 'hotelFacilities', 'time': time, 'sessionid': sessionid}
    var FacilitiesData = this.common.encryptionData(FacilitiesDataJson, this)
    hotelFacilities(FacilitiesData).then(res => {
      this.hotelFacilities = res.data
      this.hotelFacilitiesHeight = Math.ceil((300 + this.hotelFacilities.length * 25) / 4) + 'px'
    })
  },
  mounted () {
    // 存储来源
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      source = localStorage.getItem('source')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          }
        }
      }
    }
    // 下滑搜索条置顶
    window.addEventListener('scroll', this.handleScroll)

    // 实现swiper双向控制
    this.$nextTick(() => {
      if (this.$refs.swiperTop !== undefined) {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      }
    })

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

    // 页面被刷新
    // if (window.performance.navigation.type === 1) {
    //   localStorage.removeItem('searchData')
    // }

    // 获取报价
    this.hotelPrice()

    // 查城市ID
    this.getCityIdFun()

    // 关闭弹出
    window.addEventListener('click', this.bodyCloseMenus)
    // 回退按钮
    window.addEventListener('popstate', this.handleBackForwardButton)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 870) {
        this.mapMobile = 1
      } else {
        this.mapMobile = 0
      }
    },
    language: function (newCur, oldCur) {
      this.language = newCur
      if (this.language === 'zh') {
        this.pet_notice = this.hotelPolicy.pet_notice_zh_arr
      } else {
        this.pet_notice = this.hotelPolicy.pet_notice_en_arr
      }
    },
    currencySwitch: function (newCur, oldCur) {
      this.reload()
      this.hotelPrice()
    },
    isPriceShow: function (newCur, oldCur) {
      console.log(newCur, oldCur)
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.bodyCloseMenus)
    window.removeEventListener('popstate', this.handleBackForwardButton)
  },
  methods: {
    getLanguageHtml: function (data, type) {
      var getLanguage = this.common.languageSet(this)
      if (type === 'hotelname') {
        if (getLanguage === 'zh') {
          var name = this.hotel.hotelname_zh
          if (this.hotel.hotelname !== '' && this.hotel.hotelname !== undefined) {
            name = this.hotel.hotelname_zh + ' (' + this.hotel.hotelname + ')'
          }
          return name
        } else {
          return this.hotel.hotelname
        }
      } else if (type === 'hoteladdr') {
        if (getLanguage === 'zh' && this.hotel.hoteladdress_zh !== '') {
          return this.hotel.hoteladdress_zh
        } else {
          return this.hotel.hoteladdress
        }
      } else if (type === 'country' && data.countryBase !== undefined && JSON.stringify(data) !== '{}') {
        if (getLanguage === 'zh') {
          return data.countryBase.country_zh
        } else {
          return data.countryBase.country
        }
      } else if (type === 'city' && data.cityBase !== undefined && JSON.stringify(data.cityBase) !== '{}') {
        if (getLanguage === 'zh') {
          return data.cityBase.city_zh
        } else {
          return data.cityBase.city
        }
      } else if (type === 'hotel_location') {
        if (getLanguage === 'zh') {
          return data.hotel_location_zh
        } else {
          return data.hotel_location_en
        }
      } else if (type === 'room_features') {
        if (getLanguage === 'zh') {
          return data.room_features_zh
        } else {
          return data.room_features_en
        }
      } else if (type === 'distince_from' && JSON.stringify(data) !== '{}' && JSON.stringify(data) !== undefined) {
        if (getLanguage === 'zh' && data.distince_from_zh !== '' && data.distince_from_zh !== null) {
          return data.distince_from_zh
        } else if (data.distince_from_en !== undefined && data.distince_from_en !== '' && data.distince_from_en !== null) {
          return data.distince_from_en
        }
      } else if (type === 'hotel_introduction') {
        if (getLanguage === 'zh') {
          return data.hotel_introduction_zh
        } else {
          return data.hotel_introduction_en
        }
      } else if (type === 'facility_value') {
        if (getLanguage === 'zh') {
          return data.facility_value_zh
        } else {
          return data.facility_value_en
        }
      } else if (type === 'roomname') {
        if (getLanguage === 'zh') {
          return data['parentInfo'].name_cn + ' (' + data['parentInfo'].name_en + ')'
        } else {
          return data['parentInfo'].name_en
        }
      } else if (['hotelscoreStr', 'hotelscoreRemark'].includes(type)) {
        if (getLanguage === 'zh') {
          return this.$t(data) + '!'
        } else {
          return this.$t(data) + '!'
        }
      } else if (['hotelscoreStr', 'hotelscoreRemark'].includes(type)) {
        if (getLanguage === 'zh') {
          return this.$t(data) + '!'
        } else {
          return this.$t(data) + '!'
        }
      } else if (['window', 'breakfast'].includes(type)) {
        if (getLanguage === 'zh') {
          return this.$t(data)
        } else {
          return this.$t(data)
        }
      } else if (['import_notice', 'city_notice', 'child_notice', 'pet_notice', 'agelimit_notice', 'checkin_notice', 'checkout_notice', 'other_service', 'breakfast_notice', 'bed', 'special_instructions'].includes(type)) { // 政策
        if (getLanguage === 'zh') {
          return data[type + '_zh']
        } else {
          return data[type + '_en']
        }
      } else if (['facilities', 'desc', 'time'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['room-cancel'].includes(type)) {
        var html = ''
        if (getLanguage === 'zh') {
          html += data.fundableDate.year + '年' + data.fundableDate.month + '月' + data.fundableDate.day + '日 '
          html += ' ' + data.fundableDate.hour + ':00 '
          html += this.$t('freeCancellationBefore')
        } else {
          html += this.$t('freeCancellationBefore')
          html += ' ' + data.fundableDate.en
        }

        return html
      } else if (['roomarea'].includes(type)) {
        var roomareahtml = ''
        if (getLanguage === 'zh') {
          roomareahtml += data + ' sqm'
        } else {
          roomareahtml += data + ' sqm'
        }
        return roomareahtml
      } else if (['maxinum'].includes(type)) {
        var roommaxnumhtml = ''
        if (getLanguage === 'zh') {
          roommaxnumhtml += this.$t('accommodates') + data['maxinum'] + this.$t('people')
        } else {
          roommaxnumhtml += this.$t('accommodates') + ' ' + data['maxinum'] + ' ' + this.$t('people')
        }
        return roommaxnumhtml
      } else if (['floor'].includes(type)) {
        var floornumhtml = ''
        if (getLanguage === 'zh') {
          floornumhtml += data['floor'] + this.$t('floorTh')
        } else {
          floornumhtml += data['floor'] + this.$t('floorTh')
        }
        return floornumhtml
      } else if (type === 'sonroomname') {
        if (getLanguage === 'zh' && data.name_cn !== '') {
          return data.name_cn + ' (' + data.name + ')'
        } else {
          return data.name
        }
      }
    },
    hotelDetailCurrency: function (data) {
      this.currencySwitch = data
    },
    hotelLanguage (language) {
      this.language = language
    },
    // 下拉置顶
    handleScroll: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.source === 'sec') {
        if (scrollTop > 60) {
          this.hotelLogoFixed = {'position': 'fixed', 'top': '0px', 'left': '0px', 'z-index': 1994}
        } else {
          this.hotelLogoFixed = ''
        }
        if (scrollTop > 460) {
          this.hotelRoomSearchPcFixed = {'position': 'fixed', 'top': '60px', 'z-index': 1993, 'margin': '0 auto', 'width': '1100px', 'left': '0', 'right': '0', 'background': 'white'}
          this.hotelRoomSearchPcFixedPlaceholder = {'display': 'contents', 'border': 'solid 1px white'}
        } else {
          this.hotelRoomSearchPcFixed = ''
          this.hotelRoomSearchPcFixedPlaceholder = {'display': 'none'}
        }
        if (scrollTop > 900) {
          this.hotelRoomSearchMobileFixed = {'position': 'fixed', 'top': '60px', 'left': '0px', 'z-index': 1994, 'box-shadow': '0 2px 12px #ccc', 'padding': '10px', 'width': '100%', 'background': 'white'}
        } else {
          this.hotelRoomSearchMobileFixed = ''
        }
      } else {
        if (scrollTop > 60) {
          this.hotelRoomSearchFixedHeader = {'position': 'fixed', 'top': '0px', 'left': '0px', 'z-index': 1994}
          this.hotelRoomSearchFixedHeaderPlaceholder = {'display': 'block'}
        } else {
          this.hotelRoomSearchFixedHeader = ''
          this.hotelRoomSearchFixedHeaderPlaceholder = ''
        }
        if (scrollTop > 460) {
          this.hotelRoomSearchPcFixed = {'position': 'fixed', 'top': '64px', 'z-index': 1993, 'margin': '0 auto', 'width': '1100px', 'left': '0', 'right': '0', 'background': 'white'}
          this.hotelRoomSearchPcFixedPlaceholder = {'display': 'contents', 'border': 'solid 1px white'}
        } else {
          this.hotelRoomSearchPcFixed = ''
          this.hotelRoomSearchPcFixedPlaceholder = {'display': 'none'}
        }
        if (scrollTop > 900) {
          this.hotelRoomSearchMobileFixed = {'position': 'fixed', 'top': '64px', 'left': '0px', 'z-index': 1994, 'box-shadow': '0 2px 12px #ccc', 'padding': '10px', 'width': '100%', 'background': 'white'}
        } else {
          this.hotelRoomSearchMobileFixed = ''
        }
      }

      // 页签切换监控.
      if (scrollTop <= 410) {
        this.anchorJumpStatus = 'hotel-roomname'
      } else {
        // if (this.hotelOverviewTop === undefined) {
        if (document.querySelector('#hotel-overview') === null) {
          this.hotelOverviewTop = 0
        } else {
          this.hotelOverviewTop = document.querySelector('#hotel-overview').offsetTop - 200 // 之前-110, 刚好卡在线上, 但是客房已经看到尾巴了, 下一列展示很多了, 所以 就改为了-200
        }
        // }
        // if (this.hotelPoliciesTop === undefined) {
        if (document.querySelector('#hotel-policies') === null) {
          this.hotelPoliciesTop = 0
        } else {
          this.hotelPoliciesTop = document.querySelector('#hotel-policies').offsetTop - 200
        }
        // }
        // if (this.hotelfacilitiesTop === undefined) {
        if (document.querySelector('#hotel-facilities') === null) {
          this.hotelfacilitiesTop = 0
        } else {
          this.hotelfacilitiesTop = document.querySelector('#hotel-facilities').offsetTop - 200
        }
        // }
        if (this.hotelOverviewTop > 0 && scrollTop < this.hotelOverviewTop) {
          this.anchorJumpStatus = 'hotel-roomname'
        }
        if (this.hotelOverviewTop > 0 && scrollTop >= this.hotelOverviewTop && scrollTop < this.hotelPoliciesTop) {
          this.anchorJumpStatus = 'hotel-overview'
        }
        if (this.hotelPoliciesTop > 0 && scrollTop >= this.hotelPoliciesTop && scrollTop < this.hotelfacilitiesTop) {
          this.anchorJumpStatus = 'hotel-policies'
        }
        if (this.hotelfacilitiesTop > 0 && scrollTop >= this.hotelfacilitiesTop) {
          this.anchorJumpStatus = 'hotel-facilities'
        }
      }
    },
    anchorJump: function (type) {
      this.$el.querySelector('#' + type).scrollIntoView({behavior: 'smooth'})
    },
    anchorJumpLine: function (type) {
      // 方法一
      // this.$el.querySelector('#' + type).scrollIntoView({behavior: 'smooth'})

      // 方法二
      if (type === 'hotel-roomname') {
        window.scrollTo({
          top: 400,
          behavior: 'smooth'
        })
      } else if (type === 'hotel-overview') {
        const height = document.querySelector('#' + type).offsetTop
        const top = parseInt(height) - 110
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        })
      } else {
        const height = document.querySelector('#' + type).offsetTop
        const top = parseInt(height) - 110
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        })
      }

      // this.anchorJumpStatus = type
    },
    // 查看所有图片
    seeMorePicturesShow: function () {
      this.$refs.seeMorePictures.style.display = 'block'
      // 轮播默认 第一个显示
      this.imgBackShow(0)

      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[0].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[0].id)
    },
    seeMorePicturesHide: function () {
      this.$refs.seeMorePictures.style.display = 'none'
    },
    // 所有图片按钮 上一个
    prevImgShow: function () {
      var dataIndex = this.$refs.morePricturesMax.getAttribute('data-index')
      var prevIndex = dataIndex - 1
      if (prevIndex < 0) {
        prevIndex = this.hotelImg.length - 1
      }
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[prevIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[prevIndex].id)

      this.imgBackShow(prevIndex)
    },
    // 所有图片按钮 下一个
    nextImgShow: function () {
      var dataIndex = this.$refs.morePricturesMax.getAttribute('data-index')
      var nextIndex = Number(dataIndex) + 1
      if (nextIndex > (this.hotelImg.length - 1)) {
        nextIndex = 0
      }
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[nextIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[nextIndex].id)

      this.imgBackShow(nextIndex)
    },
    curImgShow: function (e) {
      var curIndex = e.target.attributes.dataIndex.value
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[curIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[curIndex].id)

      this.imgBackShow(curIndex)
    },
    imgBackShow: function (num) {
      for (var i = 0; i < this.hotelImg.length; i++) {
        this.$refs.currentPicturesDiv[i].style.background = 'gray'
      }
      this.$refs.currentPicturesDiv[Number(num)].style.background = 'none'
    },
    focusData: function () {
      // 更改日期操作记录埋点
      this.clickPageAction('hotel_change_date', this.hotelid, {'hotelid': this.hotelid})

      if (document.body.clientWidth < 1001) {
        // 尺寸如果低于1001 则触发frame
        this.$refs.child.hotelSearchFrame = true
      } else {
        // 尺寸如果高于1001
        this.$refs.child.parentFocus()
        // window.scrollTo(0, 0)
        document.querySelector('#main').scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    selectHotelList: function () {
      // var regionselect = this.$refs.child.region_select
      var startdate = this.$refs.child.start_date
      var enddate = this.$refs.child.end_date
      var room = this.$refs.child.roomNum
      var adult = this.$refs.child.adultNum
      var child = this.$refs.child.childNum

      var regionSel = {'value_en': this.cityData.city, 'value_zh': this.cityData.chinese_name, 'type_id': 1, 'type_data_id': this.cityData.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var language = this.common.languageSet(this)
      var cityRegion = this.cityData.city
      if (language === 'zh') {
        cityRegion = this.cityData.chinese_name
      }
      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }
      var searchJson = {'type': 1, 'type_id': this.cityData.id, 'region': cityRegion, 'start_date': startdate, 'end_date': enddate, 'room': room, 'adult': adult, 'child': child, 'childNums': childNums, 'source': this.source}
      if (this.conver === 1 || this.conver === '1') {
        searchJson = {'type': 1, 'type_id': this.cityData.id, 'region': cityRegion, 'start_date': startdate, 'end_date': enddate, 'room': room, 'adult': adult, 'child': child, 'childNums': childNums, 'source': this.source, 'conver': this.conver}
      }
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      // 搜索其他酒店住宿操作记录埋点
      this.clickPageAction('change_hotel', this.hotelid, searchJson)

      // this.$router.push({name: 'HotelList', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
    },
    viewDetailShow: function (e) {
      // var display = e.currentTarget.parentElement.nextElementSibling.style.display
      var display = e.currentTarget.nextElementSibling.style.display
      if (display === '') {
        e.currentTarget.nextElementSibling.style.display = 'none'
      } else {
        e.currentTarget.nextElementSibling.style.display = ''
      }
    },
    // 页面筛选
    checkedBox: function (type) {
      // 点击操作记录埋点
      if (type === 'breakfast') {
        this.clickPageAction('meal_type', this.mealType, {'hotelid': this.hotelid})
      } else {
        this.clickPageAction('free_cancellation', this.checked_cancel, {'hotelid': this.hotelid})
      }

      var roomListNew = this.roomList
      let anyRoomVisible = false
      for (let i of Object.keys(roomListNew)) {
        var imgShow = 0
        var isbreakfast = 0
        var iscancel = 0
        var showPrice = roomListNew[i]['priceInfo'].length

        for (let k of Object.keys(roomListNew[i]['priceInfo'])) {
          roomListNew[i]['priceInfo'][k]['imgIsShow'] = false
          roomListNew[i]['priceInfo'][k]['selected'] = true

          // 是否含早
          if (this.mealType !== 'any') {
            if (roomListNew[i]['priceInfo'][k].breakfast !== this.mealType) {
              roomListNew[i]['priceInfo'][k]['selected'] = false
            } else {
              if (isbreakfast === 0) {
                isbreakfast = 1
                imgShow = k
              }
            }
          }
          // 是否可取消
          if (this.checked_cancel === true) {
            if (roomListNew[i]['priceInfo'][k].fundable === 'nonFefundable') {
              roomListNew[i]['priceInfo'][k]['selected'] = false
            } else {
              if (iscancel === 0) {
                iscancel = 1
                imgShow = k
              }
            }
          }

          // 判断房型是否展示
          if (roomListNew[i]['priceInfo'][k]['selected'] === false) {
            showPrice -= 1
          }
        }
        roomListNew[i]['parentInfo']['parentRoomShow'] = showPrice <= 0 ? '0' : '1'
        if (showPrice > 0) {
          anyRoomVisible = true
        }
        roomListNew[i]['priceInfo'][imgShow]['imgIsShow'] = true

        roomListNew[i]['parentInfo']['curPrice'] = roomListNew[i]['priceInfo'][imgShow]['curPrice']
        roomListNew[i]['parentInfo']['curMark'] = roomListNew[i]['priceInfo'][imgShow]['curMark']
        roomListNew[i]['parentInfo']['currency'] = roomListNew[i]['priceInfo'][imgShow]['currency']
        roomListNew[i]['parentInfo']['payAtPropertyStr'] = roomListNew[i]['priceInfo'][imgShow]['payAtPropertyStr']
      }
      roomListNew.sort(function (a, b) {
        return a['parentInfo']['curPrice'] - b['parentInfo']['curPrice']
      })
      this.noFilterResult = !anyRoomVisible
      this.roomList = roomListNew
      this.$forceUpdate()
    },
    checkedBoxMobile: function (type) {
      if (type === 'breakfast') {
        if (this.checked_breakfast === true) {
          this.checked_breakfast = false
        } else {
          this.checked_breakfast = true
        }
      } else if (type === 'cancel') {
        if (this.checked_cancel === true) {
          this.checked_cancel = false
        } else {
          this.checked_cancel = true
        }
      }

      this.checkedBox()
    },
    fullScreen: function () {
      // 点击地图操作记录埋点
      this.clickPageAction('map', '', {'hotelid': this.hotelid})

      // let element = document.documentElement
      /*
      let element = document.getElementById('mapCodeID')
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.isFullscreen = !this.isFullscreen
      */
      this.mapShow = true
    },
    mapClose: function () {
      this.mapShow = false
    },
    collect: function (key, islike) {
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var language = this.common.languageSet(this)
      var dolike = parseInt(islike) === 1 ? 0 : 1
      this.hotelCollect['islike'] = dolike
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': key, 'status': dolike, 'token': token, 'time': time, 'language': language, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      // 点击收藏操作记录埋点
      this.clickPageAction('hotel_collect', '', data)

      doCollect(data).then(res => {
        if (res.flag === '001') {
          this.hotelCollect['islike'] = islike

          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'notFoundPage', params: {'querys': newQuerys}})
        } else if (res.flag === '141') {
          this.remindFaild = true
          this.remindMessage = res.msg
          this.hotelCollect['islike'] = islike
        }
      })
    },
    recommendcollect: function (key, hotelid, islike) {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      var dolike = parseInt(islike) === 1 ? 0 : 1
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }

      this.recommendHotelList[key]['islike'] = dolike

      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': hotelid, 'status': dolike, 'token': token, 'time': time, 'language': this.language, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      // 收藏酒店埋点记录
      this.clickPageAction('hotel_collect', '', data)

      doCollect(data).then(res => {
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '141') {
          this.remindFaild = true
          this.remindMessage = res.msg
          this.recommendHotelList[key]['islike'] = islike
        }
        return res
      })
    },
    // 局部刷新
    reload: function () {
      this.isPriceShow = false
      this.roomEmptyShow = false
      setTimeout(() => {
        // this.$nextTick(() => {
        //   this.isPriceShow = true
        // })
      }, 500)
    },
    // 获取报价方法
    hotelPrice: function () {
      this.common.stopScroll()
      this.isPriceShow = true
      var that = this
      // hotelQuotedprice
      var typeId = this.common.linkQuerys.hotelid
      this.hotelid = this.common.linkQuerys.hotelid
      var params = this.common.linkQuerys
      var region = this.common.linkQuerys.region
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        if (params.type === 3) {
          this.hotelid = params.type_id
          typeId = params.type_id
        }
      }
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      // var childNums = '[]'
      // if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
      //   childNums = JSON.stringify(params.childNums)
      // }
      if (params === null || JSON.stringify(params) === '{}') {
        params = this.common.linkQuerys
        this.hotelid = params.hotelid
        region = params.region
        typeId = params.hotelid
      }

      var currency = this.common.currencySet(this)
      if (currency === undefined) {
        currency = 'USD'
      }

      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.common.linkQuerys.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }
      var startdate = params.start_date
      var enddate = params.end_date
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      if (region === undefined || region === null) {
        region = ''
      }

      if (startdate === enddate) {
        var endDate = new Date(startdate)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        enddate = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }
      this.checkIn = startdate
      this.checkOut = enddate
      var localUrl = window.document.location.href
      var initUrl = sessionStorage.getItem('roompaiAccessLink')
      if (initUrl === undefined || initUrl === null || initUrl === 'null') {
        initUrl = ''
      }

      var priceDataJson = {
        'hotelid': this.hotelid,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'token': token,
        'roompaiToken': roompaiToken,
        'source': this.source,
        'sessionid': sessionid,
        'url': localUrl,
        'initUrl': initUrl,
        'linkid': this.linkid,
        'operation': 'hotelQuotedprice',
        'time': time
      }
      var priceData = this.common.encryptionData(priceDataJson, this)
      hotelQuotedprice(priceData).then(res => {
        if (res.flag === '200') {
          that.roomEmptyShow = false
          that.isPriceShow = true

          sessionStorage.setItem('hotelQuotedPriceSesstionId', res.data.sessionIdStr)

          that.roomList = {}
          that.searchPriceData = {}
          that.recommendHotelList = {}
          that.$forceUpdate()
          that.roomList = res.data.roomPriceList
          that.searchPriceData = res.data.searchPriceData
          that.$forceUpdate()

          for (var item in res.data.roomPriceList) {
            that.mobileRoomPrice[item] = false
          }
        } else {
          that.roomEmptyShow = true
          that.isPriceShow = true

          // 当前酒店无报价 查询推荐酒店
          this.searchRecommendHotel()
        }

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(priceData, res, requestTime, responseTime)
        })
      })
      this.isPriceShow = false
      this.common.canScroll()
    },
    searchRecommendHotel: function () {
      var self = this
      var typeId = this.common.linkQuerys.hotelid
      this.hotelid = this.common.linkQuerys.hotelid
      var params = this.common.linkQuerys
      var region = this.common.linkQuerys.region
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        if (params.type === 3) {
          this.hotelid = params.type_id
          typeId = params.type_id
        }
      }

      // 用户
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      // 设备
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }

      if (params === null || JSON.stringify(params) === '{}') {
        params = this.common.linkQuerys
        this.hotelid = params.hotelid
        region = params.region
        typeId = params.hotelid
      }

      var currency = this.common.currencySet(this)
      if (currency === undefined) {
        currency = 'USD'
      }

      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.common.linkQuerys.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }
      var startdate = params.start_date
      var enddate = params.end_date
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      if (region === undefined || region === null) {
        region = ''
      }

      if (startdate === enddate) {
        var endDate = new Date(startdate)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        enddate = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }
      this.checkIn = startdate
      this.checkOut = enddate
      var localUrl = window.document.location.href

      var priceDataJson = {
        'hotelid': this.hotelid,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'token': token,
        'roompaiToken': roompaiToken,
        'source': this.source,
        'sessionid': sessionid,
        'url': localUrl,
        'operation': 'recommendHotel',
        'time': time
      }
      var priceData = this.common.encryptionData(priceDataJson, this)
      recommendHotel(priceData).then(res => {
        self.recommendHotelList = res.data.list
        self.$forceUpdate()

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(priceData, res, requestTime, responseTime)
        })
      })
    },
    recommendGotoDetail: function (hotelid, hotelname, search) {
      var params = this.common.linkQuerys
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }

      var seleteds = ''
      var child = parseInt(params.child)
      var childNums = this.common.linkQuerys.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }

      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = hotelname
      detailjson['start_date'] = search.checkin
      detailjson['end_date'] = search.checkout
      detailjson['room'] = search.roomcount
      detailjson['adult'] = search.adults
      detailjson['child'] = search.childcount
      detailjson['childNums'] = seleteds
      detailjson['language'] = this.common.languageSet(this)
      detailjson['currency'] = this.common.currencySet(this)
      detailjson['source'] = this.source
      if (this.conver === 1 || this.conver === '1') {
        detailjson['conver'] = this.conver
      }

      // 选择客房操作记录
      this.clickPageAction('select_recommend_hotel', '', detailjson)

      // let routeData = this.$router.resolve({name: 'HotelDetail', query: detailjson})
      // window.open(routeData.href, '_blank')
      var newQuerys = this.common.linkEncode(detailjson, 'obj')
      this.$router.push({name: 'HotelDetail', params: {'querys': newQuerys}})
      window.location.reload()
    },
    parentRoomBook: function (product) {
      sessionStorage.setItem('productStr', JSON.stringify(product))
      this.fullscreenLoading = true

      var language = this.common.languageSet(this)
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var region = ''
      var typeId = ''
      var params = this.common.linkQuerys
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        typeId = params.type_id
      }
      // var childNums = '[]'
      // if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && JSON.stringify(params.childNums) !== undefined) {
      //   childNums = JSON.stringify(params.childNums)
      // }
      if (params === null || JSON.stringify(params) === '{}') {
        params = this.common.linkQuerys
        region = params.region
        typeId = params.hotelid
      }
      if (region === undefined || region === null) {
        region = ''
      }
      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      var startdate = params.start_date
      var enddate = params.end_date
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.common.linkQuerys.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        } else {
          seleteds = []
        }
      }
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      this.sendGoogleAnalysis('event', 'detail_click', {'isverify': false})

      var localUrl = window.document.location.href

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }

      var verifyJson = {
        'hotelid': this.hotelid,
        'product': JSON.stringify(product),
        'token': token,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'source': this.source,
        'sessionid': sessionid,
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'operation': 'orderBookVerify',
        'time': time
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      orderBookVerify(verifyData).then(res => {
        this.fullscreenLoading = false
        console.log(res)
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)

          // this.$router.push({name: 'login', query: {'source': this.source}})
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (['155', '150'].includes(res.flag)) {
          // 无母房型有报价
          if (language === 'zh') {
            this.frameHotelSoldDialog = true
          } else {
            this.frameHotelSoldEnDialog = true
          }
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (res.flag === '153') {
          // 涨价
          this.frameRiseDialog = true
          this.risePrice = res.data.priceRise
        } else if (res.flag === '163') {
          this.frameChangeRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
        } else if (res.flag === '173') {
          this.frameChangePriceAndRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
          this.risePrice = res.data.priceRise
        } else if (res.flag === '200') {
          // 成功
          var orderData = {
            'hotelid': this.hotelid,
            'product': JSON.stringify(product),
            'checkin': startdate,
            'checkout': enddate,
            'room': room,
            'adult': adult,
            'child': child,
            'source': this.source,
            'childNums': seleteds,
            'hotelUrl': localUrl,
            'conver': this.conver
          }
          localStorage.setItem('orderData', JSON.stringify(orderData))
          orderData['querys'] = newQuerys
          this.$router.push({name: 'WriteOrder', params: orderData})
        } else if (res.flag === '102') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        }
        return res
      }).then(res => {
        this.$nextTick(() => {
          // 埋点日志记录
          var bookNow = {
            'product_price': product.totalprice,
            'product_currency': product.currency,
            'product_id': product.id,
            'product_subid': product.subid,
            'hotelid': this.hotelid,
            'checkin': startdate,
            'checkout': enddate,
            'adults': adult,
            'child': child,
            'room': room
          }
          this.clickPageAction('book_now', '', bookNow, verifyData, res)
        })
      })
    },
    getSearchInfo: function (val) {
      console.log(this.common.linkQuerys)
      console.log(val)

      console.log(val['region'])
      console.log(this.region)
      this.checked_breakfast = false
      this.checked_cancel = false

      this.roomList = []
      var type = val['type']
      if (type === undefined) {
        type = 3
      }
      var typeId = val['type_id']
      if (typeId === undefined) {
        typeId = this.common.linkQuerys.hotelid
      }
      var regionSelArrOld = val['regionSelArrOld']
      console.log('regionSelArrOld', regionSelArrOld)
      var region = ''
      if (regionSelArrOld !== '{}' && regionSelArrOld !== null && regionSelArrOld !== 'null') {
        var language = this.common.languageSet(this)
        if (language === 'zh') {
          region = regionSelArrOld.value_zh
        } else {
          region = regionSelArrOld.value_en
        }
        if (region !== undefined) {
          this.region = region
        }
      }
      var search = {}
      search['type'] = type
      search['type_id'] = typeId
      search['region'] = val['region']
      search['start_date'] = val['start_date']
      search['end_date'] = val['end_date']
      search['room'] = val['room']
      search['adult'] = val['adult']
      search['child'] = val['child']
      search['childNums'] = val['childNums']
      search['source'] = val['source']
      if (this.conver === 1 || this.conver === '1') {
        search['conver'] = this.conver
      }
      localStorage.setItem('searchData', JSON.stringify(search))

      console.log(val['region'])
      console.log(this.region)

      var newQuerys = ''
      if (val['region'] !== this.region) {
        newQuerys = this.common.linkEncode(search, 'obj')
        this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
      } else {
        var time = parseInt(new Date().getTime() / 1000)
        var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
        query.start_date = val['start_date']
        query.end_date = val['end_date']
        query.room = val['room']
        query.adult = val['adult']
        query.child = val['child']
        query.childNums = []
        query.childNums = val['childNums']
        query.ss = time
        if (this.conver === 1 || this.conver === '1') {
          query.conver = this.conver
        }

        newQuerys = this.common.linkEncode(query, 'obj')
        this.$router.push({path: this.common.routePath(this.$route.path) + '/' + newQuerys})

        this.reload()
        this.hotelPrice()

        window.scrollTo({
          top: 400,
          behavior: 'instant'
        })
      }
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    getCityIdFun: function () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.cityData = res.data.hotelCity
      })
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'room-info-pc') {
        var element = document.getElementsByClassName('room-info-desc')
        for (var i = 0; i < element.length; i++) {
          element[i].style.display = 'none'
        }
      }
    },
    mobileRoomShow: function (i) {
      if (this.mobileRoomPrice[i] === false) {
        this.mobileRoomPrice[i] = true
      } else {
        this.mobileRoomPrice[i] = false
      }
      this.$forceUpdate() // 加这个是因为有时候点击页面会没反应
    },
    closepopEven: function (type) {
      if (type === 'whatNearbyShow') {
        this.whatNearbyShow = false
      }
      if (type === 'facilitiesShow') {
        this.facilitiesShow = false
      }
      if (type === 'hotelPriceRoomImgShow') {
        this.hotelPriceRoomImgShow = false
      }
    },
    // 查看房型
    lookRoomList: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var top = this.$refs.roominfo.offsetTop
      var topHeight = top - 74
      if (scrollTop === 0) {
        topHeight = top - 138
      }
      window.scrollTo({
        top: topHeight,
        behavior: 'instant'
      })
    },
    // 手机版 详情页 价格展示
    selectRoomPriceDetail: function (price) {
      this.hotelRoomPriceDetailDialog = true
      this.priceDetailData = price
    },
    hotelRoomPriceDetailCloseFun: function () {
      this.hotelRoomPriceDetailDialog = false
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.main{overflow:hidden;}
.main{background-color: #fff;width:100%;}
.el-container .el-header{position: unset;}
.text-font-hidden{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
{unicode-bidi: isolate;font-variant-numeric: tabular-nums; text-transform: none;text-indent: 0px !important;text-align: start !important;text-align-last: start !important;}
.hotel-room-clear{height:15px;}

/* PC */
  /* 搜索条件 开始 */
  .list-search{width: 100%;height: 64px;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;background-color: rgba(79, 76, 76, 1);margin: 0 auto;}
  .location-search{height:48px;width:70%;margin: 0 auto;}
  /* 目的地 */
  .input-region{width: 361px; height: 48px;}
  .location-search .hotellist-region{width:35%;}
  .hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-region input:focus,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus,.hotellist-person.el-select .el-input__inner:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}

  /* 查看更多图片 */
  .hotel-detail-info-pc .seeMorePictures{width:100%;height:100%;display:none;}
  .hotel-detail-info-pc .seeMorePictures .pricturesMask{width:100%;height:100%;background:black;position:fixed;top:0px;left:0px;z-index:10001;/* opacity: 0.6 !important; */}
  .hotel-detail-info-pc .seeMorePictures .morePrictures{position: fixed;z-index: 10002;top: 20%;left: 10%;width: 100%;height: 70%;}
  .hotel-detail-info-pc .seeMorePictures .morePrictures .morePricturesImg{float:left;width:80%;height:100%;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft{width: 65%;height: 100%;float:left;position: relative;text-align: center;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft img{/* width: 100%;*/height: 100%; max-width: -webkit-fill-available;max-height: -webkit-fill-available;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft span{font-size: 77px; position: absolute; top: 40%;height:13%;  color: white; font-weight: 100;cursor:pointer;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft .firstSpan{left: 0px;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft .lastSpan{right: 0px;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft .firstSpan img{width: 70px;height: 100%;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesLeft .lastSpan img{width: 70px;height: 100%;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesRight{width: 35%;height:100%;float:right;overflow-y: scroll;overflow-x: hidden;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesRight::-webkit-scrollbar {width: 2px;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesRight .morePricturesRightImg{width: 48%; height: 100px;float: left;margin: 2px;position:relative;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesRight .morePricturesRightImg img{width: 100%;height: 100%;}
  .hotel-detail-info-pc .seeMorePictures .morePricturesRight .morePricturesRightImg div{width: 100%;height: 100%; background: gray;position: absolute;top: 0px;left: 0px;opacity: 0.6;}
  .hotel-detail-info-pc .seeMorePictures .closeRight{width: 40px;height: 100%;float: left;text-align: center;line-height: 20px;}
  .hotel-detail-info-pc .seeMorePictures .closeRight span{font-size: 54px;color: white;font-weight:100;cursor:pointer;}

  /* 日期 */
  .hotellist-date{padding: 0px 50px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
  .input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 23px;background-position: 0px center;}
  .hotellist-date .el-range__icon{margin-left:0px;}

  /* 入住人 */
  .location-search .hotellist-person{width:20%;}
  .hotellist-person .el-input__inner{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .inphotellistut-person .el-input__inner:hover{border-color:rgb(252, 210, 5, 1);}
  .el-select-dropdown{display:none;}

  /* 搜索 */
  .hotellist_button{width:120px;height:48px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
  .hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
  /* 搜索条件 结束 */
  /* 搜索结果 开始 */
  .list-content{/*width: 70%;*/width:1100px;margin: 15px auto;}
  /* 导航 */
  .directory{height:22px;width:100%;font-size: 12px;text-align: left;}
  .directory a{text-decoration:none;color: #4F4C4C;}
  .slash{color: #C0C4CC;padding:0px 5px 0px 5px;}

  /* 详情 */
  .hotel-detail{width:100%}
  /* 酒店名称地址 */
  .hotel-detail-data{margin-bottom:10px;}
  .hotel-detail-info .hotel-detail-name{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal; font-size: 26px;}
  .hotel-detail-star{padding-left: 14px;color: rgba(252, 210, 5, 1);}
  .hotel-detail-info .hotel-detail-addr{color:#333333;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal; font-size: 14px; width:100%; margin:0 auto;}
  /* 酒店图片其他 */
  .hotel-detail-describe{height:300px;}
  .hotel-detail-describe .hotel-detail-img{width:59%;height:100%;float:left;}
  .hotel-detail-describe .hotel-detail-other{width:40%;height:100%;float:right;}
  .hotel-detail-img .hotel-detail-img-max{width:65%;height:100%;float:left;}
  .hotel-detail-img .hotel-detail-img-min{width:34%;height:49%;float:right;}
  .hotel-detail-img .hotel-detail-img-love{margin-bottom: 6px;position:relative;}
  .hotel-detail-img .hotel-detail-img-all{position:relative;}
  .hotel-detail-img .hotel-imgs{width:100%;height: 100%;border-radius:4px;}
  .hotel-detail-img-love .hotel-img-love{position: absolute;top: 15px;right: 15px;width:38px;cursor:pointer;}
  .hotel-detail-img-all span{position: absolute;bottom: 10px;right: 10px;color: white;font-size: 12px; border: solid 1px #ccc;border-radius: 3px; padding: 3px 12px;background: rgba(149,141,134,0.3);font-weight: bold;cursor:pointer;}
  /* .hotel-detail-img-love .hotel-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;background-image: url('https://res.roompai.com/static/img/hotelsearch/20220615-141545.png');}
  .hotel-detail-img-love .hotel-like-0:hover{background-image: url('https://res.roompai.com/static/img/hotelsearch/20220615-141557.png');}
  .hotel-detail-img-love .hotel-like-1{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;background-image: url('https://res.roompai.com/static/img/hotelsearch/20220615-141552.png');} */
  .hotel-detail-img-love .hotel-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill: pink;}
  .hotel-detail-img-love .hotel-like-0:not(.no-hover):hover{fill: rgb(255, 120, 120);}
  .hotel-detail-img-love .hotel-like-1{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill:red;}

  .no-hover{fill:red;}
  /* 酒店评价 */
  .hotel-detail-other .hotel-detail-evaluate-map{width:100%;height:35%;}
  .hotel-detail-other .hotel-detail-device-around-division{width: 100%;height: 5px;position: relative;}
  .hotel-detail-other .hotel-detail-device-around-division img{width: 100%;height: 2px;position: absolute;top: 8px;}
  .hotel-detail-other .hotel-detail-device-around{width:100%;height:63%;/*border-top: dashed 1px #EBEEF0;*/}
  .hotel-detail-evaluate-map .hotel-detail-evaluate{width:31%;height:95%;background:#ccc;text-align:center;border:solid 1px #504D4D;border-radius:3px;float:left;}
  .hotel-detail-evaluate .hotel-detail-evaluate-num{width:100%;height:40%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #FCD205;background-color: rgba(79, 76, 76, 1);border-radius:3px 3px 0 0;line-height:40px;font-size:15px;}
  .hotel-detail-evaluate-num span{border: dotted 1px;border-radius: 50%;padding: 5px;text-align: center;height: 20px;width: 20px;line-height: 20px;display: inline-block;}
  .hotel-detail-evaluate .hotel-detail-evaluate-desc{width:100%;height:60%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 100;font-style: normal;color: #FCD205;background-color:#FFFBEA;border-radius:0 0 3px 3px;line-height:60px;color:#4F4C4C;font-size:14px;}

  /* 酒店地图 */
  .hotel-detail-evaluate-map .hotel-detail-map{width:68%;height:95%;text-align:center;float:right;}
  .hotel-detail-map .hotel-detail-map-img{width: 40%;height: 100px;float:left;margin-right:3%;}
  .hotel-detail-map .hotel-detail-map-info{width: 55%;height: 100%;float:left;}
  .hotel-detail-map-img img{width: 85%;height: 100%;border: dotted 1px #eee;border-radius: 4px;}
  .hotel-detail-map-info .map-info{width:100%;height:33%;text-align:left;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 10px;}
  .hotel-detail-map-info .map-info img{width:20px;height:20px;margin-top: 6px;vertical-align:middle;float:left;}
  .map-info .map-info-flag{float:left;text-align:left;width:60%;height:100%;}
  .map-info .map-info-flag span{line-height: 30px; padding-left: 8px;display: block; overflow: hidden; white-space:nowrap;text-overflow: ellipsis;font-size:12px;}
  .map-info .map-info-data{float:right;text-align:right;width:39%;height:100%;line-height: 30px;overflow: hidden; white-space: nowrap;}

  /* 酒店设施周边 */
  .hotel-detail-device-around .device-around-class{width:100%;height:88%;margin-top: 3.5%;}
  .hotel-detail-device-around .hotel-detail-device{width:31%;height:100%;float:left;border-right: dotted 1px #EBEEF0;}
  .hotel-detail-device-around .hotel-detail-around{width:68%;height:100%;float:right;}

  /* 酒店设施 */
  .hotel-detail-device .hotel-detail-device-line{width:100%;height:18%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;color: #4F4C4C;}
  .hotel-detail-device .more-line{width:100%;height:6%;font-family: PingFangSCRegular, 'PingFang SC Light', 'PingFang SC', sans-serif;font-weight: 200;font-style: normal;font-size: 10px;color:#5392F9;cursor:pointer;}
  .hotel-detail-device .hotel-detail-device-line img{width:20px;height:20px;float:left;margin-top:3px;}
  .hotel-detail-device .hotel-detail-device-line span{line-height: 25px;padding-left: 8px;display: block;width: 70%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-size:12px;}

  /* 酒店周边 */
  .hotel-detail-around .hotel-detail-around-line{width:100%;height:18%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;color: #4F4C4C;padding-left: 10px;}
  .hotel-detail-around .more-line{width:100%;height:6%;font-family: PingFangSCRegular, 'PingFang SC Light', 'PingFang SC', sans-serif;font-weight: 200;font-style: normal;font-size: 10px;color:#5392F9;cursor:pointer;}
  .hotel-detail-around .first-line{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 16px;color: #4F4C4C;}
  .hotel-detail-around .hotel-detail-around-line img{width:14px;height:14px;float:left;margin-top:5.3px;margin-right:6px;}
  .hotel-detail-around .hotel-detail-around-line span{line-height: 25px;padding-left: 8px;display: block;overflow: hidden;white-space: nowrap;float: left;width: 41.7%;text-overflow:ellipsis;font-size:12px;}
  .hotel-detail-around-line .around-line-mileage{text-align:right; font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 10px;color:#A6A6A6;}

  /* 酒店房型描述title */
  .hotel-room-desc-seach{width:100%;height:40px;border-radius: 4px;border:solid 1px #DCDFE2;font-family: PingFangSCRegular, 'Arial', sans-serif;font-weight: 650;font-style: normal;font-size: 14px;}
  .hotel-room-desc-seach .hotel-room-title-left{float:left;}
  .hotel-room-desc-seach .hotel-room-title-right{float:right;}
  .hotel-room-desc-seach .hotel-room-title{cursor:pointer;height: 37px;line-height: 40px;padding: 0px 2px;width: auto;float: left;text-align: center;margin:0px 15px 0px;}
  .hotel-room-desc-seach .hotel-room-active{color:#5392F9;border-bottom:solid 3px #5392F9;}
  .hotel-room-title-right .hotel-room-button{width: auto;padding: 0px 20px;height: 40px;line-height:40px;float:left;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;text-align: center;border: solid 1px #DCDFE2;border-bottom: none;border-top: none;border-radius: 20px;margin-right: 10px;}
  .hotel-room-title-right .hotel-room-select{width: auto;padding: 0px 20px;height: 40px;line-height:40px;float:left;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;text-align: center;border-bottom: none;border-top: none;border-radius: 20px;margin-right: 10px;}

  .meal-select /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    border:none;
    padding: 0 0 0 20px;
    /* border-radius: 0px 20px 20px 0px;
    border-left: 1px solid #DCDFE6; */
  }
  .meal-select /deep/ .el-input__icon {
    line-height: 40px;
  }

  .meal-select-mini  /deep/ .el-input__inner {
    height: 28px;
    line-height: 28px;
    border-radius: 20px;
    border: none;
    padding: 0 0 0 20px;
    /* border-radius: 0px 20px 20px 0px;
    border-left: 1px solid #DCDFE6; */
  }
  .meal-select-mini /deep/ .el-input__icon {
    line-height: 30px;
  }

  .hotel-room-title-right .hotel-room-select-mini {
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }

  .hotel-room-seach-pc .meal-select:hover /deep/ .el-checkbox__inner {border-color: #fff;background-color: #5392F9!important;}
  .hotel-room-seach-pc .hotel-room-button:hover /deep/ .el-checkbox__inner {border-color: #fff;background-color: #5392F9!important;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button:hover{background: #5392F9;border: solid 1px #5392F9;border-bottom: none;border-top: none;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button:hover /deep/ .el-checkbox__label{color:white;}

  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input{width: 14px;height: 14px;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input .el-checkbox__inner{background:rgb(0,0,0,0)!important;border-color: #DCDFE6;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input{vertical-align: middle!important;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__label{vertical-align: revert!important;line-height: 20px;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color:white;}
  .hotel-room-seach-pc .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{border-color:white;}
  .room-price-clear{height:7px;}
  .content-empty-text{font-size: 14px;color: #4F4C4C;text-align: center;}
  .content-empty-img{width:200px; height:200px; margin-top: 10px;}
  .parent-room-price-refresh{min-height:300px;line-height:300px;width:100%;text-align: center;}
  .parent-room-price-refresh .content-refresh-img{width:50px;height:50px;margin-top: 10px;-webkit-filter: opacity(90%); /* Chrome, Safari, Opera */ filter: opacity(90%);-webkit-transform: rotate(360deg);animation: rotation 3s linear infinite;-moz-animation: rotation 3s linear infinite;-webkit-animation: rotation 3s linear infinite;-o-animation: rotation 3s linear infinite;}
  @-webkit-keyframes rotation{
      from {-webkit-transform: rotate(0deg);}
      to {-webkit-transform: rotate(360deg);}
  }

  /* 酒店房型价格 */
  .hotel-room-price-title, .hotel-room-empty{width:100%;}
  .hotel-room-price-title .room-price-title{width:100%;height:35px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;line-height:35px;border-radius: 6px 6px 0px 0px;border: solid 1px #DCDFE2;}
  .hotel-room-empty{width:100%;text-align:center;min-height:300px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;line-height:35px;border-radius: 6px 6px 0px 0px;border: solid 1px #DCDFE2;}
  .room-price-title .room-title{width:11%;height:100%;float:left;text-indent:1rem;}
  .room-price-title .beds-title{width:22%;height:100%;float:left;text-indent:1rem;}
  .room-price-title .breakfast-title{width:12%;height:100%;float:left;text-indent:1rem;}
  .room-price-title .cancel-title{width:25%;height:100%;float:left;text-align:left;}
  .room-price-title .price-title{width:15%;height:100%;float:left;text-align:right;}
  .room-price-title .button-title{width:15%;height:100%;float:left;text-indent:1rem;}

  /* 母房型 */
  .parent-room-price{width:100%;}
  .parent-room-price .parent-room{width:100%;height:40px;background:rgba(252, 210, 5, 1);line-height:40px;border-left:solid 1px #DCDFE2;border-right:solid 1px #DCDFE2;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 16px;}
  .parent-room div{text-indent:1rem;}

  /* 床型价格 */
  .parent-room-price .beds-price{width:100%;min-height:115px;border-right:solid 1px #DCDFE2;border-left:solid 1px #DCDFE2;}
  .beds-price .beds-price-line{width:100%;height:115px;}
  .beds-price .beds-price-line:hover{background:#FFFBE6;}
  .beds-price .beds-price-line:hover .room-title-img{background:#fff;}
  .beds-price-line .room-title-img{width:11%;height:100%;box-shadow: 1px 0 0 #DCDFE2;float:left;position:relative;}
  .beds-price-line .room-title-img .room-info-desc{padding: 20px 0px 10px;position: absolute; top: 0px; left: 101%; width: 370px; height: 85px; background: white; box-shadow: 2px 2px 12px rgb(0 0 0 / 10%);}
  .beds-price-line .room-title-img .room-info-desc .room-info{float: left; width: 43%;height: 33%; font-size: 12px;padding-left: 5%;}
  .beds-price-line .room-title-img .room-info-desc .room-info .room-info-text{display: inline-block;vertical-align: middle;}
  .beds-price-line .room-title-img .room-info-desc .room-bed-info .room-info-text{display: inline-block;vertical-align: middle;}
  .beds-price-line .room-title-img .room-info-desc .room-bed-info{float: left; width: 100%;height: 33%; font-size: 12px;padding-left: 5%;}
  .beds-price-line .room-title-img .room-info-desc .room-bed-info .room-info-img{width: 19px;vertical-align: middle;}
  .beds-price-line .room-title-img .room-info-desc .room-info .room-info-img{width: 19px;vertical-align: middle;}
  .beds-price-line .room-beds-img{height:100%;width:90%;margin:0 auto;border-radius:4px;position:relative;}
  .room-beds-img img{height: 77px;width:100%;margin-top: 15px;border-radius: 4px;}
  .room-beds-img div{position:absolute;bottom:24px;width:100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif; font-weight: 400; font-style: normal;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;}
  .room-beds-img .no-room-img{bottom:45px;height:35px;line-height:35px;}

  .beds-price-line {font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;text-align: left;}
  .beds-price-line .beds-title-data{width:21%;height:100%;float:left;line-height:114px;box-shadow: 0 1px 0 #dcdfe2; padding-left: 1%;}
  .others .beds-price-line .beds-title-data{width: 26%;}
  .others-room{height: 40px;line-height: 20px; margin: 22.5px 0 5px 0; display: -webkit-box; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis; max-width: 100%;-webkit-box-orient: vertical;}
  .beds-price-line .breakfast-title-data{width:12%;height:100%;float:left;/*text-indent:1rem;*/line-height:114px;text-indent:1rem;box-shadow: 0 1px 0 #dcdfe2;}
  .beds-price-line .breakfast-title-data .breakfastColor{color:#2F7000;}
  .beds-price-line .cancel-title-data{width:25%;height:100%;float:left;box-shadow: 0 1px 0 #dcdfe2;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height:114px;text-align: left;}
  .beds-price-line .cancel-title-data div{padding-top: 15px;/*overflow: hidden;*/white-space: nowrap;text-overflow: ellipsis;}
  .beds-price-line .cancel-title-data .fontColorGreen{color:#2F7000;}
  .green-color{color: #2F7000;}
  .beds-price-line .cancel-title-data /deep/ .cancel-title-data-cont{overflow: hidden;width:100%;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line /deep/ .cancel-title-data-cont{overflow: hidden;width:100%!important;}
  .beds-price-line .price-title-data{width:15%;height:100%;float:left;/*text-indent:1rem;*/text-align:right;box-shadow: 0 1px 0 #dcdfe2;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .beds-price-line .price-title-data .price-title-data-center{width: 100%;height: 100%;line-height: 114px;}
  .beds-price-line .price-title-data .price-title-data-top{width: 100%;height: 55%;line-height: 100px;}
  .beds-price-line .price-title-data .price-title-data-bottom{width: 100%;height: 45%;}
  .beds-price-line .price-title-data .price-title-data-bottom .font-7F-10{font-size: 10px;color: #7F7F7F;display: block;text-indent:0rem;}
  .beds-price-line .button-title-data{width:15%;height:100%;float:left;text-indent:1rem;box-shadow: 0 1px 0 #dcdfe2;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .beds-price-line .button-title-data /deep/ button{margin-right:20px}
  .button-title-data .button-title-data-reserve{padding-top: 32px;text-align:right;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .button-title-data button{width: 129px;height: 51px;background-color: rgba(252, 210, 5, 1);border-radius: 4px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 16px;color: #4F4C4C;cursor: pointer;border:none;}
  .button-title-data button:hover{background-color: rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);}
  .beds-price-line .beds-price-line-lastimg{box-shadow: 1px 1px 0 #dcdfe2;}
  .price-padding{padding-bottom:20px;}

  /* 查看更多 */
  .parent-room-price .look-more{width:100%;border:solid 1px #dcdfe2;border-top:none;text-align:center;padding:5px 0px;border-radius: 0 0 4px 4px;cursor:pointer;}
  .parent-room-price .look-more div{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 12px;color: #4F4C4C;}
  .parent-price-clear{height:20px;}

  /* 概览 */
  .hotel-overview{width:100%;}
  .hotel-overview .overview-title{width:100%;height:50px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 16px;line-height:50px;border-radius: 6px 6px 0px 0px;border: solid 1px #DCDFE2;text-indent:1rem;}
  .hotel-overview .overview-body{width:100%;border-radius: 0px 0px 6px 6px;border: solid 1px #DCDFE2;border-top:none;overflow: hidden;}
  .overview-body .overview-center{width:97%;margin:0 auto;}
  .overview-center .overview-body-line{width:100%;height:35px;line-height: 35px;padding:5px 0px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-size: 14px;}
  .overview-center .overview-body-line div{height:100%;padding-right:40px;float:left;}
  .overview-center .overview-body-line span{font-weight:bold;}
  .overview-center .overview-body-desc {padding:5px 0px;}
  .overview-center .overview-body-desc span{/*text-indent:1rem;*/font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;text-align: left;}
  .overview-center .overview-body-addr{padding:16px 0px;font-size:14px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;}
  .overview-center .overview-body-addr span{font-weight: 650;}
  .overview-center .overview-body-feature{padding:16px 0px;font-size:14px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;}
  .overview-center .overview-body-feature span{font-weight: 650;}

  /* 政策 */
  .overview-body .overview-left{width:15%;text-indent:1rem;float:left;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-size:14px;padding:10px 0px;}
  .overview-body .overview-right{width:85%;float:left;padding:10px 0px;}
  .overview-right .instructions-data{width:50%;min-height:100px;float: left;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-style: normal;font-size: 14px;text-align: left;}
  .instructions-data .instructions-data-title{font-weight: 650;}
  .instructions-data .instructions-data-cont{width:90%;padding: 5px 0px 20px 20px;}
  .instructions-data .instructions-data-reference{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;color: #F46109;font-size:12px;}
  /deep/ .instructions-data-cont ul{list-style-type: decimal!important;}

  /* 设施 */
  .overview-instructions-data{width:96%;/*margin:0 auto;*/height:365px;padding:20px 10px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif; font-style: normal;font-size: 14px;text-align: left;line-height: 26px;overflow-x: auto;}
  .overview-instructions-data::-webkit-scrollbar { display: none;}
  .overview-instructions-data ul{height: 100%;width: 25.7%;font-size:14px;-webkit-column-gap: 12px;-webkit-column-count: 1;column-gap: 12px;column-count: 1;-moz-column-gap: 12px;-moz-column-count: 1;-moz-column-rule: 1px solid #d8d8d8;}

  .overview-instructions-data ul li{display:block;}
  .inst-title{font-weight: 650;}
  .inst-cont{font-weight: 400;font-size:12px;}
  .inst-title-top{margin-top: 16px;}
  .inst-title,.inst-title-top,.inst-cont .inst-text{vertical-align: middle;}
  .inst-img{width:20px;height:20px;vertical-align: text-top;}
  /deep/ .el-card{overflow: unset;}
/* 手机端 */
  /* 酒店图片 */
  .hotel-detail-info-mobile hr{background:#DDDFE2}
  .hotel-detail-info-mobile .hotel-detail-describe{height:auto;}
  .hotel-detail-info-mobile .hotel-detail-img{height:300px;width:100%;float:left;}
  .hotel-detail-info-mobile .hotel-detail-img .thumb-example {width: 100%;height:100%; }
  .hotel-detail-info-mobile .hotel-detail-img .swiper-slide {background-size: cover;background-position: center;}
  .hotel-detail-info-mobile .hotel-detail-img .gallery-top {height: 225px;width: 100%;}
  .hotel-detail-info-mobile .hotel-detail-img .gallery-thumbs {height: 25% !important;box-sizing: border-box;padding: 10px 0px; width: 100%;background: #ddd}
  .hotel-detail-info-mobile .hotel-detail-img .gallery-thumbs .swiper-slide {width: 20%;border: 2px solid #ddd;}
  .hotel-detail-info-mobile .hotel-detail-img .gallery-thumbs .swiper-slide-active {border: 2px solid white;}
  /* 酒店信息 */
  .hotel-detail-info-mobile .hotel-detail-star{padding-left: 0px;color: rgba(252, 210, 5, 1);}
  .hotel-detail-info-mobile .hotel-detail-evaluate{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 12px;}
  .hotel-detail-info-mobile .hotel-detail-evaluate .hotel-detail-score{color: rgb(83, 146, 249);}
  /*.hotel-detail-info-mobile .hotel-detail-evaluate .hotel-detail-quality-evaluate span{border: solid 1px #32832E;color: #32832E;padding: 1px 5px;border-radius: 2px;margin-right: 20px;}*/
  .hotel-detail-quality-evaluate .hotel-detail-quality-all{margin: 4px 8px 8px 0px; padding-left: 4px; padding-right: 4px; flex-wrap: nowrap; -webkit-box-align: center;align-items: center;display: inline-block;border-radius: 4px; padding: 2px 8px;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-green{background-color: #F6FFED;border: 1px solid #B7EB8F; color: #52C41A;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-hone{background-color: #FEF0EF;border: 1px solid #FFA39E; color: #F5222D;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-cheng{background-color: #FFF2E8;border: 1px solid #FFBB96; color: #FA541C;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-blue{background-color: #E6F7FF;border: 1px solid #91D5FF; color: #1890FF;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-qing{background-color: #E6FFFB;border: 1px solid #87E8DE; color: #13C2C2;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-fen{background-color: #FFF0F6;border: 1px solid #FFADD2; color: #F5317F;}
  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-zi{background-color: #F9F0FF;border: 1px solid #D3ADF7; color: #722ED1;}

  .hotel-detail-info-mobile .hotel-detail-love .hotel-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;cursor: pointer;fill: pink;}
  .hotel-detail-info-mobile .hotel-detail-love .hotel-like-1{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;cursor: pointer;fill:red;}

  .hotel-detail-info-mobile .hotel-detail-addr-map{width:100%;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-evaluate-map .hotel-detail-map{width:100%;text-align:left;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-map-info{width: 67%;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-map-img{width: 30%;height:90px;}

  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-map-info img{width: 20px;height: 20px;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-addr{width: 100%;height: 20px; margin-top: 10px;font-size:12px;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-addr img{/*width:14px;*/height:14px;float:left;padding-top:3px;}
  .hotel-detail-info-mobile .hotel-detail-addr-map .hotel-detail-addr span{line-height:20px;float:left;width:90%;padding-left: 5px;display: block;/*overflow: hidden;white-space: nowrap;text-overflow: ellipsis;*/float: left;}

  /* 探索周边 */
  .hotel-detail-info-mobile .hotel-detail-around-line{padding-left:0px;height:30px;float:left;}
  .hotel-detail-info-mobile .hotel-detail-around-line-last{height:20px;}
  .hotel-detail-info-mobile .hotel-detail-around-line span{width:40%;float:left;padding-left:0px;}
  .hotel-detail-info-mobile .hotel-detail-around-line .around-line-mileage{float:right;}
  .hotel-detail-info-mobile .hotel-detail-around-line .more-around{color: #5392f9;}

  /* 设施 */
  .hotel-detail-info-mobile .hotel-detail-around-all{width: 100%;overflow-x: auto;}
  .hotel-detail-info-mobile .hotel-detail-around-all::-webkit-scrollbar { display: none;}
  .hotel-detail-info-mobile .hotel-detail-around-all .hotel-detail-around-one {white-space: nowrap;font-size: 0;margin: 10px 0px 0px;}
  .hotel-detail-info-mobile .hotel-detail-around-all .hotel-detail-around-one .hotel-detail-device-line{font-size: 12px;box-sizing: border-box;white-space: normal;word-wrap: break-word;word-break: break-all;overflow: hidden;display: inline-block;/*width: 25%;*/text-align:center;/* height: 100%; border: 1px solid #000; */margin:0px 10px 0px 0px; min-width: 20%;}
  .hotel-detail-info-mobile .hotel-detail-around-all .hotel-detail-around-one .hotel-detail-device-line img{width: 22px;height:22px;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button{width: auto; padding: 0px 10px; height: 30px; line-height: 30px; float: left; font-family: PingFangSCRegular, 'PingFang SC', sans-serif; font-weight: 400; font-style: normal; font-size: 14px; text-align: center; border: solid 1px #DCDFE2; border-radius: 20px; margin-right: 7px;}

  .hotel-detail-info-mobile .hotel-detail-star{color: rgba(252, 210, 5, 1);width:35%;float:left;margin-top: 3px;}
  .hotel-detail-info-mobile .hotel-detail-score-all{color: rgba(252, 210, 5, 1);float:right;}

  .hotel-detail-info-mobile .hotel-detail-quality-evaluate .hotel-detail-quality-all{margin: 0px 0px 0px 0px; padding-left: 4px; padding-right: 4px; flex-wrap: nowrap; -webkit-box-align: center;align-items: center;display: inline-block;border-radius: 4px; padding: 2px 8px;}

  /* 房型搜索 */
  .hotel-room-seach-mobile {border:none;}
  .hotel-room-seach-mobile .hotel-room-title{width:100%;margin:0px;text-align:left;}
  .hotel-room-seach-mobile .hotel-room-title .hotel-room-button{width: 110px;height: 40px;line-height:40px;float:left;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;text-align: center;border-left: solid 1px #DCDFE2;border-right: solid 1px #DCDFE2;border-radius: 20px;}

  /* 房间预订 */
  .button-title-data .button-data-mobile{padding-top:unset;line-height: 114px;}
  .button-title-data .button-data-mobile button{width:auto;height:auto;padding: 5px 10px;}

/* 手机报价 */
  .hotel-detail-info-mobile .hotel-detail-name{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal; font-size: 16px;}
  .hotel-room-20{height:20px;}

  /* 房型搜索 */
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input{width: 14px;height: 14px;vertical-align: middle!important;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__label{vertical-align: middle!important;line-height:13px;height:13px;font-size:12px;}

  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input .el-checkbox__inner{background:rgb(0,0,0,0)!important;border-color: #DCDFE6;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input{vertical-align: middle!important;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color:white;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{border-color:white;}
  .hotel-room-seach-mobile .hotel-room-button:active /deep/ .el-checkbox__inner {border-color: #fff;background-color: #5392F9!important;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button:active{background: #5392F9;}
  .hotel-room-seach-mobile .hotel-room-title-right .hotel-room-button:active /deep/ .el-checkbox__label{color:white;}

  .hotel-room-price-mobile .hotel-room-empty{width:95%; margin:0 auto;}
  .hotel-room-price-mobile .parent-room-price {width:100%; height:100%;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-info-center{width:95%; margin:0 auto; height:100%;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-info{width:100%; height:130px}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line{width:100%;float:left;border-bottom:solid 1px #DDDFE2;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line{width:100%;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line-price{width:100%;min-height: 50px;line-height: 50px;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line-price .room-beds-line-price-info{width:50%;height:100%;display:inline-block;float:left;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line-price .beds-line-price{float:left;display:block;line-height: 60px;height: 35px;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line-price .beds-line-button{float:right;display:block;line-height:35px;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .room-beds-line-price .beds-line-button button{width: 100px;height: 35px;background-color: rgba(252, 210, 5, 1);border-radius: 4px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;color: #4F4C4C;cursor: pointer;border:none;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .breakfastColor{color:#008A8A;}
  .hotel-room-price-mobile .parent-room-price .room-beds-price-line .fontColorGreen{color:#008A8A;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-active{box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);border-radius: 5px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left{width:50%; height:100%;float:left;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right{width:50%; height:100%;float:right;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left .parent-room-price-left-top{width:100%; height:40%;overflow: hidden;font-size:14px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left .parent-room-price-left-bottom{width:100%; height:30%;overflow: hidden;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-top{width:100%; height:49%;overflow: hidden;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-center{width:100%; height:30%;overflow: hidden;text-align:right;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .pay-at-property-div{width:100%; overflow: hidden;text-align:right; float: right;width: 210px;height: 46%;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .pay-at-property-div .pay-at-property-span{display:block;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .pay-at-property-div .font-7F-10{font-size:10px;color:#7F7F7F;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-bottom{width:100%; height:21%;overflow: hidden;position: relative;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left .parent-room-price-left-conf{float:left;color:#999999;font-size:12px;margin-top:20px;padding: 0px 5px 0px 0px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left .parent-room-price-left-conf:not(:first-child){padding: 0px 5px 0px 5px;border-left: solid 1px #999999;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-left .parent-room-price-left-conf-bed{float:left;color:#999999;font-size:12px;margin-top: 10px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-top .no-default-img{width: 31%;height: 70%;float: right;margin-top: 10px;border-radius: 4px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-top .default-img{height: 70%;float: right;margin-top: 10px;border-radius: 4px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-bottom img{width: 15px; height: 15px;float: right;border-radius: 4px;position: absolute;right:0px;bottom: 11px;}
  .hotel-room-price-mobile .parent-room-price .parent-room-price-right .parent-room-price-right-center .parent-room-price-right-price{margin: 10px 0px;font-size: 24px;color: #E12D2D;}
  .hotel-room-price-mobile .hotel-info-hotelRelated{/*font-family: PingFangSCMedium, 'PingFang SC Semibold', 'PingFang SC', sans-serif;*/ font-weight: 650; font-style: normal;color: #4F4C4C;}
  .hotel-room-price-mobile /deep/ .el-card{border:none;}
  .hotel-detail-info-mobile /deep/ .el-card{border:none;}
  /deep/ .el-card{overflow: unset;}

  .hotel-room-price-mobile .hotelmoney{font-weight: 650;font-size: 20px;color: #E12D2D;}
  .hotel-room-price-mobile .currency-text{font-weight: 400;font-size: 10px; margin-right: 5px;}

  /* 概览 */
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top{width:100%;min-height: 50px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top-active{box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);border-radius: 5px;}
  .hotel-detail-info-mobile .hotel-data-info /deep/ .el-card__body{width:100%;height:100%;padding: unset;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-text{margin: 10px;width: 50%;min-height: 30px;line-height: 30px;float: left;font-size: 14px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img{margin: 10px 20px;width: 10%;min-height: 30px;line-height: 30px;float: right;text-align:right;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img img{width:15px;height:15px;vertical-align: middle;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom{font-size:12px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-line{width:100%;height:35px;line-height: 35px;padding:5px 0px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-size: 14px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-line{width:100%;height:35px;line-height: 35px;padding:5px 0px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-size: 14px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-line div{height:100%;padding-right:20px;padding-left:10px;float:left;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-line span{font-weight:bold;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-desc {padding: 10px;border-bottom: solid 1px #ccc;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-addr {padding: 10px;border-bottom: solid 1px #ccc;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-feature {padding: 10px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-addr span{font-weight:bold;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .overview-body-feature span{font-weight:bold;}

  /* 通知 */
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .instructions-data {padding: 10px 10px 0px 10px;border-bottom: solid 1px #ccc}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .instructions-data .instructions-data-title{margin: 5px 0px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .instructions-data .instructions-data-cont{padding: 5px 0px 20px 20px;}
  .hotel-detail-info-mobile .hotel-data-info .hotel-data-info-bottom .instructions-data .instructions-data-cont2{padding: 5px 0px 20px 0px;}

  /* 查看房型 */
  .hotel-detail-info-mobile .hotel-detail-room-show{height: 67px; width: 100%; margin: 0 auto; position: fixed;bottom: 0px;background: white;z-index: 108;box-shadow: 0px 50px 10px 50px #ccc;}
  .hotel-detail-info-mobile .hotel-detail-room-show button{width: 96%;height: 48px;background-color: rgba(252, 210, 5, 1);border-radius: 4px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 13px;color: #4F4C4C;cursor: pointer;border:none;margin:10px 2%;}
  .room-price-clear-70{height:70px;}

  .hotel-detail-info-mobile .hotel-room-clear{height:10px;}
  .hotel-detail-info-mobile .demarcation-line {height:21px;}
  .hotel-detail-info-mobile .demarcation-line img{width:100%;margin:10px 0px;}

  .hotel-detail-info-mobile .hotel-detail-data{margin-bottom:0px;}

/* 手机样式 修改 */
  .margin-auto-98{width:95%; margin:0 auto;margin-bottom: 5px;}
  .hotel-detail-info-mobile .hotel-detail-name{width:95%; margin:0 auto 10px;}
  .hotel-detail-info-mobile .hotel-detail-addr{width:95%; margin:0 auto;}
  .hotel-detail-info-mobile .hotel-detail-evaluate{width:95%; margin:0 auto;}
  .hotel-detail-info-mobile .hotel-detail-addr-map{width:95%; margin:0 auto;}
  .hotel-detail-info-mobile .hotel-detail-around{width:95%; margin:0 auto;}
  .hotel-detail-info-mobile .hotel-detail-around-all{width:95%; margin:0 auto;}
  .hotel-room-seach-mobile .hotel-room-title-right{width:95%; margin:0 auto;height: 20px;}
  .hotel-room-price-mobile .parent-room-price{width:95%; margin:0 auto;min-height: 130px;margin-bottom: 10px;}
  .hotel-room-price-mobile .parent-room-price /deep/ .el-card__body{width:100%;height:100%;padding: unset;}
  .hotel-room-price-mobile .hotel-info-hotelRelated{width:95%; margin:0 auto;margin-bottom: 10px;}

  .hotel-detail-info-mobile .hotel-data-info{width:95%; margin:0 auto;}

/* 图片 */
  .hotel-detail-info-mobile .swiper-button-prev, .swiper-button-next{width:30px;height:30px;}

/* 推荐酒店 */
  .hotel-room-recommend /deep/ .el-card__body{padding: 0px;}
  .hotel-room-recommend .recommend-title{width:100%;height:50px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 16px;line-height:50px;border-radius: 6px 6px 0px 0px;border: solid 1px #DCDFE2;text-indent:1rem;}
  .hotel-room-recommend .recommend-body{width:100%;border-radius: 0px 0px 6px 6px;border: solid 1px #DCDFE2;border-top:none;overflow: hidden;overflow-x: auto;height:355px; white-space: nowrap;}
  .hotel-room-recommend .recommend-body::-webkit-scrollbar {height: 0px;}
  .hotel-room-recommend .el-card {margin-right:10px;}
  .hotel-room-recommend /deep/ .el-row {margin-right:10px; white-space: nowrap;}
  .hotel-room-recommend /deep/ .row-col{display: inline-block; float:none;}
  .hotel-room-recommend .home-img{position: relative;top:0px;left:0px;width:100%;}
  .hotel-room-recommend .home-img .home-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;cursor: pointer;fill: pink;position:absolute;top:5px;right:5px;}
  .hotel-room-recommend .home-img .home-like-1{width:30px;height:30px;cursor: pointer;fill:red;position:absolute;top:5px;right:5px;}
  .hotel-room-recommend .picinfo{position:relative; width:100%;height:100%;}
  .hotel-room-recommend .picinfo .no-room-img{bottom:45px;height:35px;line-height:35px;}
  .hotel-room-recommend .picinfo .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
        text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .hotel-room-recommend .hotel-name{font-weight: 500;font-style: normal;font-size: 13px;color: #4F4C4C; height:50px;margin-top:8px;white-space: pre-wrap;}
  .hotel-room-recommend .hotel-star{color:#FCD205; height:30px;}
  .hotel-room-recommend .hotel-addr{font-size: 12px;color: #4F4C4C;font-weight: 100; min-height:40px;white-space: pre-wrap;}
  .hotel-room-recommend .hotel-br{height: 20px;}
  .hotel-room-recommend .hotel-height15{height: 15px;}
  .hotel-room-recommend .hotel-price{text-align:right;font-weight: 650;font-style: normal;font-size: 18px;color: #E12D2D;margin: 0px 5px;}

  .hotel-room-recommend .hotel-infos{padding: 0px 10px;}
  .hotel-room-recommend .hotel-infos span{display:block;}
  .hotel-room-recommend .row-col .hotel-image{width:100%; height:151px;}

/* 推荐酒店 手机 */
  .hotel-room-recommend-mobile .home-img{position: relative;top:0px;left:0px;width:30%;height:100%;float:left;}
  .hotel-room-recommend-mobile .home-img .home-like-1{width:30px;height:30px;cursor: pointer;fill:red;position:absolute;top:5px;right:5px;}
  .hotel-room-recommend-mobile .picinfo{position:relative; width:100%;height: 100%;}
  .hotel-room-recommend-mobile .picinfo .no-room-img{bottom:45px;height:35px;line-height:35px;}
  .hotel-room-recommend-mobile .picinfo .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
        text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .hotel-room-recommend-mobile .hotel-name{font-weight: 500;font-style: normal;font-size: 12px;color: #4F4C4C; min-height:40px;line-height: 40px;text-indent: 10px;}
  .hotel-room-recommend-mobile .hotel-name span{white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
  .hotel-room-recommend-mobile .hotel-star{color:#FCD205; height:30px;}
  .hotel-room-recommend-mobile .hotel-addr{font-size: 8px;color: #4F4C4C;font-weight: 100; min-height:40px;}
  .hotel-room-recommend-mobile .hotel-br{height: 25px;}
  .hotel-room-recommend-mobile .hotel-height15{height: 15px;}
  .hotel-room-recommend-mobile .hotel-price{text-align:right;font-weight: 650;font-style: normal;font-size: 18px;color: #E12D2D;margin-right: 20px;}
  .hotel-room-recommend-mobile .hotel-infos{padding: 0px;width:70%;float:left;height:90px;}
  .hotel-room-recommend-mobile .hotel-infos span{display:block;}
  .hotel-room-recommend-center .hotel-room-recommend-mobile .row-col .hotel-image{width:100%; height:100%;}

/* 响应式 */
  @charset "UTF-8";

  @media only screen and (max-width:390px){
    header .header-middle{width:98%;}
    .main .location-search{width:98%;}
    .main .list-content{width:100%;}
    .list-content .directory{display:none;}
    /* 酒店信息区 */
    .main .list-content{margin:0px auto;}
    .hotel-detail-info-pc{display:none;}
    .hotel-detail-info-mobile{}

    /* 房型搜索 */
    .hotel-room-seach-pc{display:none;}
    .hotel-room-seach-mobile{}

    /* 房型报价 */
    .hotel-room-price-pc{display:none}
    .hotel-room-price-mobile{}

    /* 预订 */
    .button-data-pc{display:none;}
    .button-data-mobile{}

    /* 房价价格展示 */
    .price-title-data .price-title-data-desc,.price-title-data-cur{display:none;}

    /* 带框的 */
    .hotel-overview,.hotel-room-price-title{margin-left:-1px;}
  }

  @media only screen and (min-width:390px) and (max-width:490px){
    header .header-middle{width:98%;}
    .main .location-search{width:98%;}
    .main .list-content{width:100%;}
    .list-content .directory{display:none;}
    /* 酒店信息区 */
    .main .list-content{margin:0px auto;}
    .hotel-detail-info-pc{display:none;}
    .hotel-detail-info-mobile{}

    /* 房型搜索 */
    .hotel-room-seach-pc{display:none;}
    .hotel-room-seach-mobile{}

    /* 房型报价 */
    .hotel-room-price-pc{display:none}
    .hotel-room-price-mobile{}

    /* 预订 */
    .button-data-pc{display:none;}
    .button-data-mobile{}

    /* 房价价格展示 */
    .price-title-data .price-title-data-desc,.price-title-data-cur{display:none;}

    /* 带框的 */
    .hotel-overview,.hotel-room-price-title{margin-left:-1px;}
  }

  @media only screen and (min-width:490px) and (max-width:768px){
    header .header-middle{width:98%;}
    .main .location-search{width:98%;}
    .main .list-content{width:100%;}
    .list-content .directory{display:none;}
    /* 酒店信息区 */
    .main .list-content{margin:0px auto;}
    .hotel-detail-info-pc{display:none;}
    .hotel-detail-info-mobile{}

    /* 房型搜索 */
    .hotel-room-seach-pc{display:none;}
    .hotel-room-seach-mobile{}

    /* 房型报价 */
    .hotel-room-price-pc{display:none}
    .hotel-room-price-mobile{}

    /* 预订 */
    .button-data-pc{display:none;}
    .button-data-mobile{}

    /* 房价价格展示 */
    .price-title-data .price-title-data-desc,.price-title-data-cur{display:none;}

    /* 带框的 */
    .hotel-overview,.hotel-room-price-title{margin-left:-1px;}
  }

  @media only screen and (min-width:768px) and (max-width:870px){
    header .header-middle{width:98%;}
    .main .location-search{width:98%;}
    .main .list-content{width:100%;}
    .list-content .directory{display:none;}

    /* 酒店信息区 */
    .main .list-content{margin:0px auto;}
    .hotel-detail-info-pc{display:none;}
    .hotel-detail-info-mobile{}

    /* 房型搜索 */
    .hotel-room-seach-pc{display:none;}
    .hotel-room-seach-mobile{}

    /* 房型报价 */
    .hotel-room-price-pc{display:none}
    .hotel-room-price-mobile{}

    /* 预订 */
    .button-data-pc{display:none;}
    .button-data-mobile{}

    /* 房价价格展示 */
    .price-title-data .price-title-data-desc,.price-title-data-cur{display:none;}

    /* 带框的 */
    .hotel-overview,.hotel-room-price-title{margin-left:-1px;}
  }

  @media only screen and (min-width:870px) and (max-width:992px){
      header .header-middle{width:98%;}
      .main .list-content{width:100%;}
      .hotel-detail-evaluate .hotel-detail-evaluate-num{font-size:12px;}

      /* 酒店信息区 */
      .hotel-detail-info-pc{}
      .hotel-detail-info-mobile{display:none;}

      /* 房型搜索 */
      .hotel-room-seach-pc{}
      .hotel-room-seach-mobile{display:none;}

      /* 房型报价 */
      .hotel-room-price-pc{}
      .hotel-room-price-mobile{display:none}

      /* 预订 */
      .button-data-pc{}
      .button-data-mobile{display:none;}
  }

  @media only screen and (min-width:992px) and (max-width:1200px){
      header .header-middle{width:98%;}
      .hotel-detail-evaluate .hotel-detail-evaluate-num{font-size:12px;}
      .main .list-content{width:1100px;}

      /* 酒店信息区 */
      .hotel-detail-info-pc{}
      .hotel-detail-info-mobile{display:none;}

      /* 房型搜索 */
      .hotel-room-seach-pc{}
      .hotel-room-seach-mobile{display:none;}

      /* 房型报价 */
      .hotel-room-price-pc{}
      .hotel-room-price-mobile{display:none}

      /* 设备pc */
      .overview-instructions-data{overflow-x: unset;}

      /* 预订 */
      .button-data-pc{}
      .button-data-mobile{display:none;}
  }

  @media only screen and (min-width:1200px) and (max-width:1400px) {
      header .header-middle{width:98%;}
      .main .list-content{width:1100px;}

      /* 酒店信息区 */
      .hotel-detail-info-pc{}
      .hotel-detail-info-mobile{display:none;}

      /* 房型搜索 */
      .hotel-room-seach-pc{}
      .hotel-room-seach-mobile{display:none;}

      /* 房型报价 */
      .hotel-room-price-pc{}
      .hotel-room-price-mobile{display:none}

      /* 设备pc */
      .overview-instructions-data{overflow-x: unset;}

      /* 预订 */
      .button-data-pc{}
      .button-data-mobile{display:none;}
  }

  @media only screen and (min-width:1400px) and (max-width:1920px) {
      /* 酒店信息区 */
      .hotel-detail-info-pc{}
      .hotel-detail-info-mobile{display:none;}

      /* 房型搜索 */
      .hotel-room-seach-pc{}
      .hotel-room-seach-mobile{display:none;}

      /* 房型报价 */
      .hotel-room-price-pc{}
      .hotel-room-price-mobile{display:none}

      /* 设备pc */
      .overview-instructions-data{overflow-x: unset;}

      /* 预订 */
      .button-data-pc{}
      .button-data-mobile{display:none;}
  }

  @media only screen and (min-width:1920px) {
      /* 酒店信息区 */
      .hotel-detail-info-pc{}
      .hotel-detail-info-mobile{display:none;}

      /* 房型搜索 */
      .hotel-room-seach-pc{}
      .hotel-room-seach-mobile{display:none;}

      /* 房型报价 */
      .hotel-room-price-pc{}
      .hotel-room-price-mobile{display:none}

      /* 设备pc */
      .overview-instructions-data{overflow-x: unset;}

      /* 预订 */
      .button-data-pc{}
      .button-data-mobile{display:none;}
  }
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/HotelDetail.vue